
<!-- Start: Rejwan: 09-02-2026 Front Routes -->
<template>
    <b-overlay :show="showoverlaymodal" rounded="sm" class="pf_loan_form_front row">
        <div class="col-sm-12" :class="edit_form ? 'col-md-8' : 'col-md-12'">
            <b-form @submit.stop.prevent="onSubmit">
                {{checkName}}
                <div class="row col-12 no-margin px-0">
                    <!-- Start: Rejwan: 01-12-2025 -->
                    <div class="ibox col-md-12  pf-loan-form no-shadow border">
                        <div class="ibox-title dashboard_title">
                            <h4 class="clearfix">
                                <span class="float-left">Employee Info</span>
                                <span class="float-right"></span>
                            </h4> 
                        </div>
                        <div class="ibox-content px-0">
                            <div class="row text-center">
                                <div class="col-lg-4">
                                    <h3>Employee Name: {{ employee_details.name }}</h3>
                                    <h3>Emplopyee Code: {{ employee_details.code }}</h3>
                                </div>
                                <div class="col-lg-4">
                                    <h3>Date of Joining: {{ employee_details.date_of_joining }}</h3>
                                    <h3>PF Start Date: {{ employee_details.pf_start_date }}</h3>
                                </div>
                                <div class="col-lg-4">
                                    <h3>PF Membership Period: {{ employee_details.membership_period }}</h3>
                                    <h3>Service Length: {{ employee_details.service_length }}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End: Rejwan: 01-12-2025 -->

                    <div class="ibox col-md-12  pf-loan-form no-shadow border">
                        <div class="ibox-title dashboard_title">
                            <h4 class="clearfix">
                                <span class="float-left">Balance Info</span>
                                <span class="float-right"></span>
                            </h4> 
                        </div>
                        <div class="ibox-content px-0">
                            <div class="row">
                                <div class="col-lg-4 col-md-6 col-sm-12 cursor-pointer">
                                    <div class="shortcut-button">
                                        <span>
                                            <h3>
                                                Total Provident Fund Balance
                                            </h3>
                                            <span>{{formatMoney(total_pf_balance)}}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 cursor-pointer">
                                    <div class="shortcut-button">
                                        <span>
                                            <h3>
                                                Eligible Balance for Advance
                                            </h3>
                                            <span>{{formatMoney(total_eligible_balance)}}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 cursor-pointer">
                                    <div class="shortcut-button">
                                        <span>
                                            <h3>
                                                Existing Advance Balance
                                            </h3>
                                            <span>{{formatMoney(existing_loan_balance)}}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ibox col-md-12 ibox col-md-12 border-0">
                        <div class="ibox-title dashboard_title">
                            <h4 class="clearfix">
                                <span class="float-left">Advance Details</span>
                                <span class="float-right"></span>
         
                            </h4>
                        </div>
                        <div class="ibox-content px-1 pb-0">
                            <div class="clearfix loan_card_wrapper rounded px-0 col-md-12 pb-0">
                                <div class="row" v-if="approver_settings.show == 1">
                                    <div class="col-sm-6 mt-1 mb-1" >
                                        <b-form-group id="loan_id-group" label="Advance ID" label-for="loan_id">
                                            <b-form-input id="loan_id"  name="loan_id" :disabled="disableme == true || is_self == 0 || is_self == 1" v-model="fdata.company_loan_id"  aria-describedby="loan_amount-feedback" data-vv-as="Advance Amount"></b-form-input>
                                        </b-form-group>  
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6 mt-1 mb-1">
                                        <b-form-group id="loan_amount-group" label="Advance Amount" label-for="loan_amount" class="required-field"><!-- Mustafijur: 24-08-2026 -->
                               
                                            <b-form-input id="loan_amount"  name="loan_amount" :disabled="disableamount == true || is_self == 0" v-model="fdata.loan_amount" v-validate="{ required: true }" :state="validateState('loan_amount')" aria-describedby="loan_amount-feedback" data-vv-as="Advance Amount"></b-form-input>
                                            <b-form-invalid-feedback id="loan_amount-feedback">{{ veeErrors.first('loan_amount') }}</b-form-invalid-feedback>
                                            
                                            <template v-if="pf_loan_form_disable == true">
                                                <div class="invalid-feedback" style="display:block !important;">{{ loan_amount_disable_text }}</div>
                                            </template>
                                            <template v-if="disable_submit_amount == true">
                                                <div style="min-height:30px;">
                                                    <div v-show="disable_submit_amount==true" class="mb-1"  style="font-size: 80% !important; color: #e3342f !important" id="submit-disable">Advance amount is invalid</div>
                                                </div>
                                            </template>
                                            
                                        </b-form-group>  

                                        <b-form-group id="paid_amount-group" label="Amount Paid" label-for="paid_amount" v-show="edit_form==1 && disableamount == true">
                                            <b-form-input id="paid_amount"  name="paid_amount" :disabled="disableme == true || is_self == 0" v-model="fdata.paid_amount" ></b-form-input>
                                        </b-form-group>
                                    </div>
                                    
                                    <div class="col-sm-6 mt-1 mb-1">
                                        <b-form-group id="effective_date_of_loan-group" label="Application Date" label-for="effective_date_of_loan">
                                            <b-input-group class="mb-3" >
                                                
                                                
                                                <b-form-input id="effective_date_of_loan_text"  :disabled="disableme == true || is_self == 0 || is_self == 1" name="effective_date_of_loan_text" v-model="fdata.effective_date_of_loan" v-validate="{ required: true }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('effective_date_of_loan_text')" aria-describedby="effective_date_of_loan_text-feedback" data-vv-as="Effective Date of Advance"></b-form-input>
                                                <!-- <b-form-datepicker id="day_one" @input="getAvailableMonths(fdata.effective_date_of_loan)" button-only right locale="en-US" :min="date_min" :disabled="disableme == true || is_self == 1"   v-model="fdata.effective_date_of_loan"></b-form-datepicker> -->
                                            
                                                <b-form-invalid-feedback id="effective_date_of_loan_text-feedback">{{ veeErrors.first('effective_date_of_loan_text') }}</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                        <b-form-group id="remaining_amount-group" label="Amount Reamining" label-for="remaining_amount" v-show="edit_form==1 && disableamount == true">
                                            <b-form-input id="remaining_amount"  name="remaining_amount" :disabled="disableme == true || is_self == 0" v-model="fdata.remaining_amount" ></b-form-input>
                                        </b-form-group>
                                    </div>
                                    
                                    
                
                                </div>

                                <div class="row">
                                    <div class="col-sm-6 mt-1 mb-1">
                                        
                                        <template v-if="fdata.status != 2 && is_self == 0">
                                            <b-form-group id="deduction_start_month-group-1" label="Deduction Start Month" label-for="deduction_start_month_1">
                                                <b-form-select id="deduction_start_month_1"   name="deduction_start_month_1" :disabled="disableamount == true || is_self == 0"  v-model="fdata.deduction_start_month" :options="m_lists" v-validate="{ required: true }" :state="validateState('deduction_start_month_1')" aria-describedby="deduction_start_month_1-feedback" data-vv-as="Advance Deduction Start Month"></b-form-select>
                                                <b-form-invalid-feedback id="deduction_start_month_1-feedback">{{ veeErrors.first('deduction_start_month_1') }}</b-form-invalid-feedback>
                                            </b-form-group>
                                        </template>
                                        <template v-else-if="fdata.status == 2 && is_self == 0">
                                            <b-form-group id="deduction_start_month-group-2" label="Deduction Start Month" label-for="deduction_start_month_2">
                                                <b-form-input id="deduction_start_month_2"  name="deduction_start_month_2" :disabled="disableamount == true || is_self == 0"  v-model="fdata.deduction_start_month" ></b-form-input>
                                            </b-form-group>
                                        </template>
                                        <template v-else-if="is_self == 1">
                                            <b-form-group id="deduction_start_month_1-group-3" label="Deduction Start Month" label-for="deduction_start_month_3" class="deduction_start_month_is_self">
                                                <b-form-input id="deduction_start_month_3"  name="deduction_start_month_3" :disabled="true"  v-model="fdata.deduction_start_month" v-validate="{ required: true }" :state="validateState('deduction_start_month_3')" aria-describedby="deduction_start_month_3-feedback" data-vv-as="Advance Deduction Start Month" ></b-form-input>
                                                <b-form-invalid-feedback id="deduction_start_month_3-feedback">{{ veeErrors.first('deduction_start_month_3') }}</b-form-invalid-feedback>
                                            </b-form-group>
                                        </template>
                                       
                                        
                                    </div>
                                    <div class="col-sm-6 mt-1 mb-1">
                                        <template v-if="fdata.status == '2' || fdata.status == 2">
                                            <b-form-group id="next_installment_month-group"  v-bind:label="deduction_start_month_title" label-for="next_installment_month" v-show="edit_form==1">
                                                <b-form-select id="next_installment_month" @change="changeDateAndTenure()"  :disabled="disableamount == true "  name="next_installment_month" v-model="fdata.next_installment_month" :options="m_list_2" v-validate="{ required: true }" :state="validateState('next_installment_month')" aria-describedby="next_installment_month-feedback" data-vv-as="Advance Deduction Start Month"></b-form-select>
                                                <b-form-invalid-feedback id="next_installment_month-feedback">{{ veeErrors.first('next_installment_month') }}</b-form-invalid-feedback>
                                            </b-form-group>
                                        </template>
                                        <template v-if="edit_form == 1 && disableamount == true">
                                            <b-form-group id="loan_tenure-group" label="Advance Repayment Tenure" label-for="loan_tenure">
                                                <b-form-input id="loan_tenure"  name="loan_tenure" :disabled="disableamount == true || is_self == 0" v-model="loan_tenure_label" ></b-form-input>
                                            </b-form-group>
                                        </template>
                                        <template v-else>
                                            <b-form-group id="loan_tenure-group" label="Advance Repayment Tenure" label-for="loan_tenure" >
                                                <select name="Advance repaymaent tenure" class='form-control' v-model="fdata.loan_tenure" :disabled="disableamount == true || is_self == 0" v-validate="{ required: true }" :state="validateState('loan_tenure')" aria-describedby="loan_tenure-feedback" data-vv-as="Advance repayment tenure">
                                                    <option v-for='index in tenure_list' :value='index'>
                                                        {{index }} Month(s)
                                                    </option>
                                                </select>
                                                <b-form-invalid-feedback id="loan_tenure-feedback">{{ veeErrors.first('loan_tenure') }}</b-form-invalid-feedback>
                                            </b-form-group>
                                        </template>
                
                                        
                                    </div>
                                    
                                    
                                    
                                </div>

                                <div class="row">
                                    <div class="col-sm-12 mt-1 mb-1"> 
                                        <b-form-group id="loan_reason-group" label="Reason of Advance" label-for="loan_reason">  

                                            <select name="loan_reason" id="loan_reason" :disabled="disableamount == true || is_self == 0" class='form-control' v-validate="{ required: true }" :state="validateState('loan_reason')" v-model="fdata.loan_reason" aria-describedby="loan_reason-feedback" data-vv-as="Reason of Advance">
                                                <option :value=null>
                                                    Select a Reason of Advance
                                                </option> 
                                                <option v-for='fyear in pf_loan_terms' :value='fyear.value'>
                                                    {{fyear.value}}
                                                </option>  
                                            </select>
                                            <b-form-invalid-feedback id="loan_reason-feedback" class="loan_reason_feedback">{{ veeErrors.first('loan_reason') }}</b-form-invalid-feedback>
                                        
                                        </b-form-group>   
                                    </div>  
                                </div>  

                                <template v-if="edit_form==0">
                                    <div class="row">
                                        <div class="col-sm-12 mt-1 mb-1"> 
                                            <b-form-group   label="Attachments" label-for="upload_file">
                                                <b-form-file id="upload_file" name="upload_file" v-model="upload_file" accept=".jpg, .png, .gif, .pdf , .doc , .docx" @change="checkFileType($event , 'upload_file' , ['.jpg', '.png', '.gif' , '.pdf','.docx','.doc'])" ref="upload_file" placeholder="Attach File" multiple  :file-name-formatter="formatNames" ><i class="fa-solid fa-paperclip"></i></b-form-file>
                                                
                                            </b-form-group>
                                        </div>  
                                    </div>  
                                </template>   

                                <div class="row">
                                    <div class="col-sm-12 mt-1 mb-1"> 
                                        <b-form-group id="details-group" label="Other Details" label-for="loan_details" >
                                            <b-form-textarea name="loan_details" :disabled="disableamount == true || is_self == 0" id="loan_details" placeholder="Enter something..." rows="3" max-rows="6"  v-model="fdata.details"  v-validate="{ required: false }" :state="validateState('loan_details')" aria-describedby="loan_details-feedback" data-vv-as="Advance Details"></b-form-textarea>
                                            <b-form-invalid-feedback id="loan_details-feedback">{{ veeErrors.first('loan_details') }}</b-form-invalid-feedback>
                                        </b-form-group>   

                                        <b-form-group id="confirm_terms-group"> 
                                          
                                            <b-form-checkbox id="confirm_terms"  v-model="fdata.confirm_terms" name="confirm_terms" :disabled="is_self == 0" v-validate="{ required: true }" :state="fdata.confirm_terms == 1 ? true : null" aria-describedby="confirm_terms-feedback" data-vv-as="This" value=1 unchecked-value=0 > <!-- Mustafijur: 24-08-2026 -->
                                            I solemnly declare the above-mentioned information is true, and no relevant information is omitted or distorted.
                                            </b-form-checkbox> 
                                            <b-form-invalid-feedback id="confirm_terms-feedback">{{ veeErrors.first('confirm_terms') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                        
                                    </div> 
                                </div> 
                                

                                <div class="row">
                                    <div class="col-sm-12 mt-1 mb-1"> 
                                        <a v-if="fdata.id > 0" href="javascript:void(0);" class="btn mb-2 btn-primary d-inline-block px-4"  @click="showAttachments()" >View Attachments</a>
                                        
                                        <template v-if="loan_installments.length > 0"> 
                                            <a href="javascript:void(0);" class="btn mb-2 btn-primary d-inline-block px-4"   @click="showInstallments()" >Installments</a>
                                        </template>

                                        <template v-if="$site_options && $site_options['pf_advance_awaiting_disbursement'] == 1">
                                            <a href="javascript:void(0);"  style="" class="btn mb-2 btn-primary d-inline-block px-4"  @click="showBankDetails(fdata.employee_id)" >Bank Account Details</a> 
                                        </template>
                                        <a v-if="show_reminder_button == 1" href="javascript:void(0);"  style="" class="btn mb-2 btn-primary d-inline-block px-4"  @click="sendReminderMail(fdata.id)" >Send Reminder Mail to Approver</a>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12 mt-1 mb-1">
                                        <template v-if="show_extra_installment_info==true"> 
                                                <div class="col-sm-12 mt-1 mb-1 px-0" v-if="pf_settings.pf_extra_installment.opt_value > 0" style="color: #3A52A6; font-size: 12px;">                   
                                                    <span style="font-size: 14px; color: #34444C; font-weight: 400;">Info :</span> 
                                                    As per Company Employees Provident Fund Trust Rules, 1/60th of the advance amount withdrawn by the members is payable as service charge/interest.
                                                    Accordingly, service charge/interest payable for the above advance would amount to – {{ extra_amount }} Tk.
                                                </div>
                                                
                                                
                                        </template>
                                    </div>
                                    <div class="col-sm-4 mt-1 mb-1 align-items-end justify-content-end d-none">
                                        <template v-show="loan_installments.length>0"> 
                                            <a href="javascript:void(0);"    style="background: transparent !important;" class="btn mb-3 mt-4 btn-primary p-0 border-0"    @click="showComments()" ><img :src="this.$api_url+'/images/Component-thread.png'"  class="" /></a>
                                        </template>
                                    </div>
                                </div> 
                            

                            </div>
                        </div>
                    </div>
                </div>
            
                
                <template v-if="loan_id > 0">
                <div class="row col-12 no-margin px-0">
                    <div class="ibox col-md-12 ibox col-md-12 border-0">
                        <div class="ibox-title dashboard_title">
                            <h4 class="clearfix">
                                <span class="float-left">Advance Approvals</span>
                                <span class="float-right"></span>
                            </h4>
                        </div>
                        <div class="ibox-content px-0">
                            <div class="clearfix loan_card_wrapper approval-wrapper rounded mb-3 mr-3 mb-0 col-md-12">

                                <div class="row">
                                        
                                    <div class="col-sm-8 mt-1 mb-1" v-if="loan_id > 0 && approver_settings.show == 1 && is_self == 0"> 
                                        <div class="mb-1 text-left ibox-title border-0 pl-0"><h4>Update Status</h4></div>
                                        <b-form-group id="loan_approval_status-group" label-for="loan_approval_status" >
                                            <select name="loan_approval_status" class='form-control' v-model="loan_approval_status" v-validate="{ required: true }" :state="validateState('loan_approval_status')" aria-describedby="loan_approval_status-feedback" data-vv-as="Advance Status">
                                                <option value="null">
                                                    Select status of the Advance
                                                </option>
                                                <option v-for='approval in approval_status' :value='approval.value'>
                                                    {{approval.text}}
                                                </option> 
                                            </select>
                                        <div id="loan_approval_status-feedback">{{ veeErrors.first('loan_approval_status') }}</div>
                                        </b-form-group>  
                                        
                                        <div  v-if="loan_id > 0 && approver_settings.show == 1 && loan_approval_status == 1"> 
                                            <b-form-group id="approval_comment-group" label="Comment" label-for="approval_comment">
                                                <b-form-textarea rows="3" max-rows="6" id="approval_comment"  name="approval_comment" v-model="approval_comment" ></b-form-textarea>
                                            </b-form-group>
                                        </div>

                                        <div  v-if="loan_id > 0 && approver_settings.show == 1 && loan_approval_status == 2"> 
                                            <b-form-group id="approval_comment-group" label="Reason" label-for="approval_comment">
                                                <b-form-textarea rows="3" max-rows="6" id="approval_comment"  name="approval_comment" v-model="approval_comment" ></b-form-textarea>
                                            </b-form-group>
                                        </div>

                                        <div  v-if="loan_id > 0 && approver_settings.show == 1 && loan_approval_status == 3"> 
                                            <b-form-group id="approval_comment-group" label="Reason" label-for="approval_comment">
                                                <select name="Advance Status" class='form-control' v-model="approval_comment" aria-describedby="approval_comment-feedback" data-vv-as="Advance Status">
                                                    <option value="">
                                                        Select a reason of rejection
                                                    </option>
                                                    <option v-for='approval in rejection_reason' :value='approval'>
                                                        {{approval}}
                                                    </option> 
                                                </select>
                                            </b-form-group>
                                        </div>
                                    </div> 
                                    <div class="col-sm-4 mt-1 mb-1">
                                        
                                        <div class="mb-1 text-left ibox-title border-0 pl-0"><h4>Advance Status</h4></div>
                                        <div class="text-center border rounded" style="padding:7px; margin-top:0;">{{ ln_stat[approver_settings.application_status] }}</div>
                                        
                                        <a href="javascript:void(0);"  style="" class="btn mb-2 btn-primary mt-4"  @click="showApprovalHistory()" >Approval History</a>
                                        
                                    </div>
                                    <div class="col-sm-8 mt-1 mb-1">
                                        <template v-if="approver_settings.application_status == 2 && is_self == 1">
                                            <b-form-group id="resubmit_comment-group" label="Re-Submit Comment" label-for="resubmit_comment" >
                                                <b-form-textarea name="resubmit_comment" id="resubmit_comment" placeholder="Enter your response here..." rows="3" max-rows="6"  v-model="fdata.resubmit_comment" ></b-form-textarea>
                                            </b-form-group>   
                                        </template>
                                    </div>
                                    <!-- 
                                    <div class="col-sm-4 mt-1 mb-1" v-if="loan_id > 0 && approver_settings.show == 1"> 
                                        <a href="javascript:void(0);"   class="btn mb-2 btn-primary btn-full-width"   @click="showApprovalHistory()" >Approval History</a>
                                    </div>  
                                    -->
                                    <div class="row">
                                        
                                    </div>

                                    
                                    
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
                </template>


                <div class="col-sm-12 mt-1 mb-1" v-if="loan_id > 0"> 
                    
                </div> 

                
                
                <div class="row">
                    <div class="col-sm-12 mt-1 mb-1 text-center" v-if="hide_submit_button == false">
                        <template v-if="approver_settings.show == 0 && is_self == 0">
                        
                        </template> 
                        <!--  Start: Rejwan: 13-01-2026 Reject Loan -->
                        <template v-else-if="loan_approval_status == 3">
                            <b-button class = "mt-1" style="width:200px;" type="submit" variant="primary">Reject</b-button>
                        </template>
                        <!--  End: Rejwan: 13-01-2026 Reject Loan -->
                        <template v-else>
                            <b-button class = "mt-1" style="width:200px;" type="submit" :disabled="disable_submit_all" variant="primary">Submit</b-button>
                        </template>
                        
                    </div> 
                </div>
                
                
        
                <b-modal id="bv-modal-discussion-thread" modal-class="discussion-thread" size="lg" hide-footer >
                    <template #modal-title>
                        <h4 class="mb-0">Recent comments</h4>
                    </template>
                    <div class="col-sm-12 mt-1 mb-1"> 
                        <!-- <discussion-thread :pageurl="$api_url" :ref_id="loan_id"  module="4" :company_id='company_id' :key="thread_key" ></discussion-thread> --> <!-- Start: Rejwan: 09-02-2026 Front Routes -->
                        <advance-settlement-discuss-discussion-thread-front :pageurl="$api_url" :ref_id="loan_id"  module="4" :company_id='company_id' :key="thread_key" ></advance-settlement-discuss-discussion-thread-front> <!-- Start: Rejwan: 09-02-2026 Front Routes -->
                    </div>               
                </b-modal> 


                <b-modal id="bv-modal-approval-history" size="lg" hide-footer v-bind:title="discussion_thread_title">
                    <div class="col-sm-12 mt-1 mb-1"> 
                        <!-- <approval-history :pageurl="$api_url" :application_id="loan_approver_app_id"  module="7" :company_id='company_id' :key="thread_key" ></approval-history> --> <!-- Start: Rejwan: 09-02-2026 Front Routes -->
                        <advance-settlement-approver-approval-history-front :pageurl="$api_url" :application_id="loan_approver_app_id"  module="7" :company_id='company_id' :key="thread_key" ></advance-settlement-approver-approval-history-front> <!-- Start: Rejwan: 09-02-2026 Front Routes -->
                    </div>               
                </b-modal> 

        
                <b-modal id="bv-modal-installment" size="lg" hide-footer title="Installment">
    
                    <div class="row">
                        <div class="col-sm-12 mt-1 mb-1">
                                
                            <b-form-input  class = "d-inline-block p-1 mr-2 align-middle" disabled style = 'width:48%;display:none !important;' v-model="checkInstallmentamount" name="ins"></b-form-input>
                            <b-form-input  class = "d-inline-block p-1 mr-2 align-middle" disabled style = 'width:48%;display:none !important;' v-model="onInstallmentChange" name="onInstallmentChange"></b-form-input>
                            <b-form-input  class = "d-inline-block p-1 mr-2 align-middle" disabled style = 'width:48%;display:none !important;' v-model="checkInput" name="onInstallmentChange"></b-form-input>
                            
                        
                        </div>
                    </div> 

                    <div class="row no-margin">
                        <template v-show="show_installment_click==true"> 
                            
                            <table class="employee-list-table dataTable table-overflow table-sticky" v-if="loan_installments.length > 0" >
                                
                                <thead>
                                    <tr class="table-head ">
                                        <td class="">
                                            Installment No.
                                        </td>
                                        <td class="">
                                            Type
                                        </td>
                                        <td class="">
                                            Month
                                        </td>
                                        <td class="text-center">
                                            Amount
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="table-row"  v-for="(row, index) in loan_installments" :key="index">
                                        <td class=" cursor-pointer text-left">
                                                Installment No #{{ showInstallmentLabel(index,loan_installments[index].month) }}
                                        </td>
                                        <!-- <template v-if="index < loan_installments.length - 1 "> -->
                                        <template v-if="!row.service_charge">
                                            <td class=" cursor-pointer text-left">
                                                Advance
                                            </td>
                                        </template>
                                        <template v-else>
                                            <td class=" cursor-pointer text-left">
                                                Service Charge
                                            </td>
                                        </template>
                                        <td class=" cursor-pointer text-left">
                                            {{ loan_installments[index].month }}
                                        </td>
                                        <td class="text-right" >
                                            {{ loan_installments[index].amount }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            
                        </template>
                    </div>
                </b-modal>
                
        
            </b-form>
        </div>
        <div class="col-md-4 col-sm-12 loan-comments border-left" v-if="edit_form==1">
            <h5 class="modal-title">Recent Comments</h5>
            <!-- <discussion-thread :pageurl="$api_url" :ref_id="loan_id"  module="4" :company_id='company_id' :key="thread_key" ></discussion-thread> --> <!-- Start: Rejwan: 09-02-2026 Front Routes -->
            <advance-settlement-discuss-discussion-thread-front :pageurl="$api_url" :ref_id="loan_id"  module="4" :company_id='company_id' :is_self="is_self" :key="thread_key" ></advance-settlement-discuss-discussion-thread-front> <!-- Start: Rejwan: 17-02-2026(1) Front Routes -->
        </div>
       {{ checkPFLimit }}
       <b-modal id="show_attachments" size="lg" hide-footer title="Advance Files" scrollable>
        <!-- <pf-loan-documents :pageurl="this.$api_url" flg="1" :key="flg_key" :loan_id="fdata.id"></pf-loan-documents> --> <!-- Start: Rejwan: 09-02-2026 Front Routes -->
        <pf-loan-documents-front :pageurl="this.$api_url" flg="1" :is_self="is_self" :key="flg_key" :loan_id="fdata.id"></pf-loan-documents-front> <!-- Start: Rejwan: 17-02-2026(1) Front Routes -->
       </b-modal>

       <b-modal id="bv-modal-bank" size="lg" hide-footer title="Bank Info">
            <!-- <pf-loan-bank-data-form :pageurl="this.$api_url" :employee_id="employee_id" :bdata="bdata" ></pf-loan-bank-data-form> --> <!-- Start: Rejwan: 09-02-2026 Front Routes -->
            <pf-loan-bank-data-form-front :pageurl="this.$api_url" :employee_id="employee_id" :bdata="bdata" ></pf-loan-bank-data-form-front> <!-- Start: Rejwan: 09-02-2026 Front Routes -->
        </b-modal>
    </b-overlay>

</template>

<script>

   export default{
      
       mounted() {
                        
       },
       props: ['pageurl','bn','flg','employee_id','employee_name','count','loan_id','is_custom','is_status','is_approver','is_self'],
       data(){  
           const now = new Date()
           const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
           const minDate = new Date(today);

           return {  
               loan_approval_status:null,
               approval_comment:'',
               thread_key:0,
               discussion_thread_title:'',
               flg_key:0,
               date_min:minDate,
               pf_contribution :0,
               total_pf_balance:0,
               total_eligible_balance:0,
               existing_loan_balance:0,
               remaining_installment_amount:0,
               atl_company_package_title: this.$atl_company_package_title,
               remaining_amount_money : 0,
               loan_installments:[],
               loan_type: 1,
               loan_type_select: 1,
               edit_form : 0,
               showoverlaymodal : true,  
               pf_loan_form_disable : false,  
               no_installment : true,
               edit_change_click :false,
               show_installment_click : false,
               disable_submit :false,
               disable_submit_all :false,
               disable_submit_amount :false,
               showInstallment : false,
               disableme: false,
               disableamount : false,  
               pf_settings:[],
               m_lists:[],
               m_list_2:[],
               pf_loan_terms:[],
               default_tenure:12, 
               tenure_list:[],
               fdata : {company_loan_id:'', employee_id:'',installments:[], loan_amount:'',loan_type:'',effective_date_of_loan:null ,deduction_start_month:null , core_hr:'' , loan_tenure:'',details:'',status:1,next_installment_month:'',paid_amount:'',change_deduction:"No",change_tenure:"No",loan_reason:'',paid_tenure:0,remaining_tenure:0,remaining_amount:'',custom_amount:0,core_hr:null},
               loan_status:[
                   { value: null, text: "Select..." },
                   { value: "0", text: "Decline" },
                   { value: "1", text: "Applied" },
                   { value: "2", text: "Approve" },
                   { value: "3", text: "Pause/Stop" },
               ],
               approval_status:[
                   { value: "1", text: "Approve / Forward" },
                //    { value: "2", text: "Defer" },
                   { value: "3", text: "Reject" },
               ],
               loan_type_vals:[
                   { value: "1", text: "Loan" },
                   { value: "2", text: "Advance" },
               ],

               rejection_reason:['Not Eligible for loan','Insufficient Documents','Company is not processing loan'],
               ln_stat:["Applied","Approved","Defered","Rejected"],
               show_extra_installment_info:false,
               extra_installment_info:'',
               amount_with_interest:0,
               extra_amount:0,
               company_id:0,
               approver_settings:[],
               loan_approver_app_id : 0,
               bdata: {employee_id: this.employee_id, beneficiary_name:this.employee_name, bank_name:null},
               bank_names: [
                    { value: null, text: "--Select--" },
                ],   
                bank_key:0,

                bank_data_new:[],
                deduction_start_month_title:'',
                // loan_amount_disable_text:"The Advance Amount must be less or equal to the total provident fund balance",
                loan_amount_disable_text:"The advance amount must be less or equal to the eligible balance for advance",
                upload_file:[],
                loan_tenure_label:'',
                old_repayment_tenure:0,
                old_loan_amount:0,

                show_reminder_button:0,
                hide_submit_button:false,
                approvals:0,
                employee_details: {}, // Rejwan: 01-12-2025
    
           }
       },
       methods:
       {
           validateState(ref)
           {
               if ( this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated) )
               {

                   return !this.veeErrors.has(ref);
               }
               return null;
           },
           fieldChange(e) {
            let selectedFiles = e.target.files;
            this.upload_file = [];
            if (!selectedFiles.length) {
                return false;
            }
            var name = '';
            var extensions = ["jpg", "png", "gif", "pdf" , "doc" , "docx"];
            for (let i = 0; i < selectedFiles.length; i++) {

                name = selectedFiles[i].name;
                var fileExt = name.split('.').pop();
                fileExt = fileExt.toLowerCase();
                if (extensions.indexOf(fileExt) < 0) {
                
                    this.$bvToast.toast('Uploaded file is not supported', {
                            title: `Error`,
                            variant: 'danger',
                            solid: true
                        }); 

                        this.upload_file = [];

                        return;
                }
                this.upload_file.push(selectedFiles[i]);
            }
        },
            formatNames(files) {
                return files.length === 1 ? files[0].name : `${files.length} files selected`;
            },
           
              
           showInstallments()
           {
               this.$bvModal.show('bv-modal-installment');
           },
           addNewLoan:function(x)
           {
               
               //alert("hegeegeefefef");
               this.resetForm();
               this.loan_status = [{ value: null, text: "Select..." },{ value: "1", text: "Applied" },{ value: "2", text: "Approve" }];
           },
           showInstallmentLabel(index,month)
           {
               var indexs = parseInt(index) +1 ;

               //var label = 'Installment # '+index+' on '+month;

               return indexs;
           },
           resetForm()
           {    
               this.pf_contribution = 0;
               this.amount_with_interest = 0;
               this.no_installment = true;
               this.edit_change_click = false;
               this.pf_loan_form_disable= false,   
               this.show_installment_click = false;
               this.disable_submit =false;
               this.disable_submit_all =false;
               this.disable_submit_amount =false;
               this.showInstallment = false;
               this.disableme = false;
               this.show_extra_installment_info = false; 
               this.disableamount = false,
               this.loan_installments = [];
               this.edit_form =0;
               this.fdata = {company_loan_id:'', employee_id:this.employee_id, loan_amount:'',installments:[],remaining_amount: null,next_installment_month:'',loan_type:this.loan_type, effective_date_of_loan:'' , deduction_start_month:null , loan_tenure:this.default_tenure, details:'',loan_reason:null,status:1,paid_amount:'',paid_tenure:0,remaining_tenure:0,remaining_amount:'',change_deduction:"No",change_tenure:"No",custom_amount:0,core_hr:"1"};
               this.$nextTick(() => {
                   this.$validator.reset();
               });
               this.upload_file = [];

           },  
           showAttachments()
           {
               this.$bvModal.show('show_attachments');
               this.flg_key += 1;
           },
           showComments()
           {
               this.discussion_thread_title = 'Comments';
               this.$bvModal.show('bv-modal-discussion-thread');
               this.thread_key += 1;
           },
           showApprovalHistory()
           {
               this.discussion_thread_title = 'Approval History';
               this.$bvModal.show('bv-modal-approval-history');
               this.thread_key += 1;
           },
           toMoney: function(amount)
           {
               if(amount !="0")
               {
                       if(!isNaN(amount))
                       {
                           var number = Number(amount);
                           return number;
                       }
                //        console.log('amount');
                //    console.log(amount);
                   var NumWithoutCommas = amount.replace(/,/g, '');
                   var number = Number(NumWithoutCommas).toFixed(2);
                   return number;
               }else
                   return amount;
           },
           sendReminderMail(id)
           {
               let formData = new FormData();
               formData.append('loan_id', id);
               this.showoverlaymodal = true;
               axios.post(this.$api_url+'/pf/send-reminder-mail', formData)
                   .then(function (response)
                   {   
                    this.$bvToast.toast('Mail Sent.', {
                        title: `Success`,
                        variant: 'success',
                        solid: true
                    });
                    this.showoverlaymodal = false;
                    this.$emit('childToParent'); 
                   }.bind(this))
                   .catch(function (error)
                   {
                       this.showoverlaymodal = false;
                       this.$bvToast.toast('Unable to sent mail.', {
                            title: `Error`,
                            variant: 'danger',
                            solid: true
                        }); 
                   });
           },
           getAvailablePf()
           {
               let formData = new FormData();
               
               formData.append('employee_id', this.employee_id);
               formData.append('loan_application', 'yes'); 
               
               // Start: Rejwan: 17-02-2026(1) Front Routes
                let url = '';
                if(this.is_self == 1)
                    url = this.$api_url_front+'/self/pf/employee/available-amount';
                else
                    url = this.$api_url_front+'/pf/employee/available-amount';
                // End: Rejwan: 17-02-2026(1) Front Routes


               // axios.post(this.$api_url+'/front/pf/employee/available-amount', formData) // Start: Rejwan: 17-02-2026(1) Front Routes
                axios.post(url, formData) // Start: Rejwan: 17-02-2026(1) Front Routes
                   .then(function (response)
                   {    
                       this.total_pf_balance = response.data.pf_balance;
                       this.total_eligible_balance = response.data.loan_eligible_balance;
                       
                       this.getExisitingLoanBalance();
                   }.bind(this))
                   .catch(function (error)
                   {
                       console.log(error);
                   });
           },
           getExisitingLoanBalance()
           {
               let formData = new FormData();
               formData.append('employee_id', this.employee_id);

               // Start: Rejwan: 17-02-2026(1) Front Routes
                let url = '';
                if(this.is_self == 1)
                    url = this.$api_url_front+'/self/pf/employee-loan-balance';
                else
                    url = this.$api_url_front+'/pf/employee-loan-balance';
                // End: Rejwan: 17-02-2026(1) Front Routes

               //    axios.post(this.$api_url+'/front/pf/employee-loan-balance', formData) // Start: Rejwan: 17-02-2026(1) Front Routes
               axios.post(url, formData) // Start: Rejwan: 17-02-2026(1) Front Routes
                   .then(function (response)
                   {    
                       this.existing_loan_balance = response.data.loan_availed - response.data.loan_returned;

                       this.pf_contribution = this.total_eligible_balance - this.existing_loan_balance;
                       
                       this.showoverlaymodal = false; 
                       
                   }.bind(this))
                   .catch(function (error)
                   {
                       console.log(error);
                   });
           },
           tenureLabel(x)
           {
                
           },
           getPFSettings: function()
           { 
               
               let currentObj = this;
            //    axios.get(this.$api_url+'/pf/settings').then(function (response) { // Start: Rejwan: 09-02-2026 Front Routes
               axios.get(this.$api_url_front+'/pf/settings').then(function (response) { // Start: Rejwan: 09-02-2026 Front Routes
                   currentObj.pf_settings = response.data.data;

                   
                   currentObj.default_tenure = currentObj.pf_settings.pf_loan_max_installment_limit.opt_value;
                   currentObj.tenure_list = Array.from({length: currentObj.default_tenure }, (_, i) => i + 1);
                   currentObj.fdata.loan_tenure = currentObj.pf_settings.pf_loan_max_installment_limit.opt_value;
                  
                       
               })  
               .catch(function (error) {
                console.log(error);
               });
               
           },
           getPFLoanTerms: function()
           { 
               
               let currentObj = this;
            //    axios.get(this.$api_url+'/company/pf-loan-terms').then(function (response) { // Start: Rejwan: 09-02-2026 Front Routes
               axios.get(this.$api_url_front+'/company/pf-loan-terms').then(function (response) { // Start: Rejwan: 09-02-2026 Front Routes
                   currentObj.pf_loan_terms = response.data;

                   
                  
                       
               })  
               .catch(function (error) {
                console.log(error);
               });
               
           },   
           getBankInfo: function(id)
           {
            let currentObj = this;
            if(!this.checkNet()) return false;

                let formData = new FormData();
                formData.append('employee_id',id);

                // Start: Rejwan: 17-02-2026(1) Front Routes
                let url = '';
                if(this.is_self == 1)
                    url = this.$api_url_front+'/self/pf/employee/bank-data';
                else
                    url = this.$api_url_front+'/pf/employee/bank-data';
                // End: Rejwan: 17-02-2026(1) Front Routes

                //axios.post(this.$api_url+'/front/pf/employee/bank-data', formData)
                // axios.post(this.$api_url+'/pf/employee/bank-data', formData) // Start: Rejwan: 09-02-2026 Front Routes
                axios.post(url, formData) // Start: Rejwan: 17-02-2026(1) Front Routes
                .then(function (response)
                {

                currentObj.bdata = response.data;

            }.bind(this));
           },         
           getLastPayrun: function(id)
           {
               if(!this.checkNet()) return false;
               let formData = new FormData();
                formData.append('employee_id',id);

                // Start: Rejwan: 17-02-2026(1) Front Routes
                let url = '';
                if(this.is_self == 1)
                    url = this.$api_url_front+'/self/pf/get-last-payrun';
                else
                    url = this.$api_url_front+'/pf/get-last-payrun';
                // End: Rejwan: 17-02-2026(1) Front Routes
                
                // axios.post(this.$api_url+'/pf/get-last-payrun', formData) // Start: Rejwan: 09-02-2026 Front Routes
                axios.post(url, formData) // Start: Rejwan: 17-02-2026(1) Front Routes
                .then(function (response)
                {
                   this.last_payrun_month = response.data;


                   var m_names = ['January', 'February', 'March',
                               'April', 'May', 'June', 'July',
                               'August', 'September', 'October', 'November', 'December'];

                   /** Get Last Payrun Date **/
                   var last_payrun_month_2 = this.last_payrun_month;
                   const str_month_arr_2 = last_payrun_month_2.split("-");
                   var payrun_year   = parseInt(str_month_arr_2[1]);
                   var p_month  = str_month_arr_2[0];
                   var payrun_month = m_names.indexOf(p_month);
                   var dt1   = 1;
                   const payrun_date = new Date(payrun_year,payrun_month,dt1);
                   payrun_date.setMonth(payrun_date.getMonth()+1);

                   this.date_min = payrun_date;

                   const now = new Date()
                    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                    const minDate = new Date(today);

                   var date_check = Date.parse(payrun_date) > Date.parse(minDate);
                   var mon = 1;
                   var gtdate = 1;
                   if(this.loan_id <= 0)
                   {

                        // console.log('DAtE CHECK = = = '+date_check);
                        // console.log('minDate = = = ');
                        // console.log(minDate);
                        // console.log('payrun_date CHECK = = =');
                        // console.log(payrun_date);
                        if(1)
                       {
                                mon = parseInt(now.getMonth())+ 1;
                                gtdate = parseInt(now.getDate());
                                if(mon < 10)
                                {
                                    mon = '0'+mon;
                                }
                                if(gtdate < 10)
                                {
                                    gtdate = '0'+gtdate;
                                }
                                this.fdata.effective_date_of_loan = now.getFullYear() + '-'+ mon + '-' + gtdate;
                                // console.log('effective_date_of_loan CHECK = = =');
                                this.getAvailableMonths(this.fdata.effective_date_of_loan);
                        }
                   }

                   /****/
               }.bind(this));
           },
           
           getInstallments()
           {
               var m_names = ['January', 'February', 'March',
                       'April', 'May', 'June', 'July',
                       'August', 'September', 'October', 'November', 'December'];
               var all_months = [];
               var all_amounts = [];
               var installments = [];
               var generate = 0;
               var pf_loan_installment_type = this.pf_settings.pf_loan_installment.opt_value;
               var pf_extra_installment = this.pf_settings.pf_extra_installment.opt_value;
               var pf_interest_rate = parseFloat(this.pf_settings.pf_interest_rate.opt_value);

               var loan_tenure = parseInt(this.fdata.loan_tenure);

            //    console.log('loan_installments getInstallments  '+ this.loan_installments.length);
               

                var loan_amount = this.toMoney(this.fdata.loan_amount);
                
                if(!this.edit_form)
                {

                    var pattern = /^(0|[1-9][0-9]{0,2}(?:(,[0-9]{3})*|[0-9]*))(\.[0-9]+){0,1}$/;
                    //if(pattern.test(this.fdata.loan_amount))
                    
                    var loan_tenure = parseInt(this.fdata.loan_tenure);
                    var old_loan_tenure = parseInt(this.fdata.loan_tenure);

                    if(pf_loan_installment_type == 'plus_one')
                    {
                        loan_tenure += parseInt(pf_extra_installment);
                    }
                    else if(pf_loan_installment_type == 'plus_one_fixed')
                    {
                        loan_tenure += parseInt(pf_extra_installment);
                    }
                    else if(pf_loan_installment_type == 'govt_interest')
                    {
                        if(loan_tenure <= 12)
                        {
                            loan_tenure +=1;
                            pf_extra_installment = 1;
                        }
                        else
                        {
                            loan_tenure +=2;
                            pf_extra_installment = 2;
                        }

                    }
                    else if(pf_loan_installment_type == 'extra_installment_limit')
                    {
                        var pf_installment_limit = parseInt(this.pf_settings.pf_installment_limit.opt_value);
                        var pf_extra_installment_after_limit = parseInt(this.pf_settings.pf_extra_installment_after_limit.opt_value);

                        var total_extra = (loan_tenure > pf_installment_limit) ? parseInt(pf_extra_installment) + pf_extra_installment_after_limit : parseInt(pf_extra_installment);

                        loan_tenure += total_extra;
                        pf_extra_installment = total_extra;
                    }

                    var start_month = this.fdata.deduction_start_month;
                    
                    
                    if(loan_amount <= 0)
                    {
                        this.disable_submit_amount =true;
                        generate =0;
                    }
                    else
                    {
                        this.disable_submit_amount =false;
                        loan_amount = Math.round(loan_amount * 100) / 100;
                        generate =1;
                    }


                    if(loan_amount < 100)
                    {
                        generate =0;
                    }
                }

                else if(this.old_repayment_tenure != 0 && (this.old_repayment_tenure!= (this.fdata.loan_tenure + this.fdata.interest_tenure)))
                {
                    
                    this.old_repayment_tenure = this.fdata.loan_tenure + this.fdata.interest_tenure;
                    var start_month = this.fdata.deduction_start_month;
                    var old_loan_tenure = parseInt(this.fdata.loan_tenure);

                    if(pf_loan_installment_type == 'plus_one')
                    {
                        loan_tenure += parseInt(pf_extra_installment);
                    }
                    else if(pf_loan_installment_type == 'plus_one_fixed')
                    {
                        loan_tenure += parseInt(pf_extra_installment);
                    }
                    else if(pf_loan_installment_type == 'govt_interest')
                    {
                        if(loan_tenure <= 12)
                        {
                            loan_tenure +=1;
                            pf_extra_installment = 1;
                        }
                        else
                        {
                            loan_tenure +=2;
                            pf_extra_installment = 2;
                        }

                    }
                    else if(pf_loan_installment_type == 'extra_installment_limit')
                    {
                        var pf_installment_limit = parseInt(this.pf_settings.pf_installment_limit.opt_value);
                        var pf_extra_installment_after_limit = parseInt(this.pf_settings.pf_extra_installment_after_limit.opt_value);

                        var total_extra = (loan_tenure > pf_installment_limit) ? parseInt(pf_extra_installment) + pf_extra_installment_after_limit : parseInt(pf_extra_installment);

                        loan_tenure += total_extra;
                        pf_extra_installment = total_extra;
                    }

                    generate =1;
                }

                else if(this.old_loan_amount != 0 && (this.old_loan_amount !=  loan_amount))
                {
                    
                    this.old_loan_amount = loan_amount;
                    var start_month = this.fdata.deduction_start_month;
                    var old_loan_tenure = parseInt(this.fdata.loan_tenure);

                    if(pf_loan_installment_type == 'plus_one')
                    {
                        loan_tenure += parseInt(pf_extra_installment);
                    }
                    else if(pf_loan_installment_type == 'plus_one_fixed')
                    {
                        loan_tenure += parseInt(pf_extra_installment);
                    }
                    else if(pf_loan_installment_type == 'govt_interest')
                    {
                        if(loan_tenure <= 12)
                        {
                            loan_tenure +=1;
                            pf_extra_installment = 1;
                        }
                        else
                        {
                            loan_tenure +=2;
                            pf_extra_installment = 2;
                        }

                    }
                    else if(pf_loan_installment_type == 'extra_installment_limit')
                    {
                        var pf_installment_limit = parseInt(this.pf_settings.pf_installment_limit.opt_value);
                        var pf_extra_installment_after_limit = parseInt(this.pf_settings.pf_extra_installment_after_limit.opt_value);

                        var total_extra = (loan_tenure > pf_installment_limit) ? parseInt(pf_extra_installment) + pf_extra_installment_after_limit : parseInt(pf_extra_installment);

                        loan_tenure += total_extra;
                        pf_extra_installment = total_extra;
                    }

                    generate =1;
                }
                


                // else if(this.edit_form && this.fdata.status == 1)
                // {
                //     var start_month = this.fdata.deduction_start_month;
                    
                //     generate =1;
                // }

               //generate =0;

            //    console.log('loan_installments getInstallments new '+ loan_tenure); 
               console.log('generate n ');
               console.log(generate);

               if(generate==1)
               {
                   const str_month_arr = start_month.split("-");
                   var yr1   = parseInt(str_month_arr[1]);
                   var mt  = str_month_arr[0];
                   var mon1 = m_names.indexOf(mt);
                   var dt1   = 1;
                   for (let i = 0; i < loan_tenure;i++)
                   {

                       var d = new Date(yr1, mon1, dt1);
                       d.setMonth(d.getMonth() + i);
                       var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();
                       all_months.push(fullText);
                   
                   }

                //    console.log('all_months');
                //    console.log(all_months);
                   
                   if(all_months.length==loan_tenure)
                   {  

                       if(pf_loan_installment_type != 'plus_one' && pf_loan_installment_type != 'plus_one_fixed' && pf_loan_installment_type != 'govt_interest' && pf_loan_installment_type != 'fixed_interest' && pf_loan_installment_type != 'extra_installment_limit')
                       {
                        //    loan_amount = Math.round(loan_amount * 100) / 100;
                        //    var frac_month_amount = loan_amount/loan_tenure;
                           
                        //    for (let i = 0; i < loan_tenure;i++)
                        //    {
                        //         all_amounts.push(frac_month_amount);
                        //    }

                            loan_amount = Math.round(loan_amount * 100) / 100;
                            var base_amount = Math.floor(loan_amount / loan_tenure);
                            var remainder = loan_amount % loan_tenure;

                            for (let i = 0; i < loan_tenure; i++)
                            {
                                all_amounts.push(i === 0 ? base_amount + remainder : base_amount);
                            }

                           console.log(1090);
                       }
                       else
                       {
                          
                           var frac_month_amount = loan_amount/old_loan_tenure;
                           frac_month_amount = Math.round(frac_month_amount  * 100) / 100;
                           console.log(1097);
                           if(pf_loan_installment_type == 'plus_one')
                           {   

                            // console.log(1101);
                            //     frac_month_amount = Math.round(frac_month_amount);
                            //     let rounded_frac_month_amount = Math.round(frac_month_amount);

                            //     // let total_installment_number  = old_loan_tenure + 1;
                            //     // let rounded_payable_amount = rounded_frac_month_amount * total_installment_number;
                            //     // let fractioned_payable_amount = rounded_payable_amount - loan_amount - frac_month_amount;

                            //     let total_installment_number  = old_loan_tenure + parseInt(pf_extra_installment);
                            //     let rounded_payable_amount = rounded_frac_month_amount * total_installment_number;
                            //     let fractioned_payable_amount = rounded_payable_amount - loan_amount - (frac_month_amount * parseInt(pf_extra_installment));
                                
                            //     let fractioned_payable_amount_pivot = fractioned_payable_amount; 
                            //     let pushed_amount = 0;
                            //     let remaining_tenure = loan_tenure;
         
                                
                            //    for (let i = 0; i < loan_tenure;i++)
                            //    {   
                            //         remaining_tenure = loan_tenure - i;
                            //         if(fractioned_payable_amount_pivot > 0 && (remaining_tenure == fractioned_payable_amount_pivot))
                            //         {   
                            //             pushed_amount = frac_month_amount - 1;
                            //             all_amounts.push(pushed_amount);
                            //             fractioned_payable_amount_pivot -= 1;
                            //         }
                            //         else if(fractioned_payable_amount_pivot < 0)
                            //         {
                            //             pushed_amount = frac_month_amount + 1;
                            //             all_amounts.push(pushed_amount);
                            //             fractioned_payable_amount_pivot += 1;
                            //         }
                            //         else
                            //         {
                            //             all_amounts.push(frac_month_amount);
                            //         }

                            //         //    if(i==0)
                            //         //    {
                            //         //        all_amounts.push(frac_month_amount);
                            //         //        continue;
                            //         //    }  
                            //         //all_amounts.push(frac_month_amount);
                            //    }
                                // Principal: integer amounts, first installment absorbs remainder
                                var principal_per_install = Math.floor(loan_amount / old_loan_tenure);
                                var principal_remainder = loan_amount % old_loan_tenure;

                                for (let i = 0; i < old_loan_tenure; i++)
                                {
                                    all_amounts.push(i === 0 ? principal_per_install + principal_remainder : principal_per_install);
                                }

                                // Service charge: floor(amount / tenure) per extra installment
                                for (let i = 0; i < parseInt(pf_extra_installment); i++)
                                {
                                    all_amounts.push(principal_per_install);
                                }
                           
                           }
                           else if(pf_loan_installment_type == 'plus_one_fixed')
                           {   
 
                            console.log(1144 );
                                // var govt_interest_amount = (loan_amount/100)*pf_interest_rate;
                                
                                // govt_interest_amount = govt_interest_amount/pf_extra_installment;

                                // govt_interest_amount = Math.trunc(govt_interest_amount*100)/100; 

                                // for (let i = 0; i < old_loan_tenure; i++)
                                // {
                                //     all_amounts.push(frac_month_amount); 
                                // }

                                // for (let i = 0; i < pf_extra_installment; i++)
                                // {
                                //     all_amounts.push(govt_interest_amount);
                                // }

                                // Principal: integer amounts, first installment absorbs remainder
                                var principal_per_install = Math.floor(loan_amount / old_loan_tenure);
                                var principal_remainder = loan_amount % old_loan_tenure;

                                for (let i = 0; i < old_loan_tenure; i++)
                                {
                                    all_amounts.push(i === 0 ? principal_per_install + principal_remainder : principal_per_install);
                                }

                                // Service charge: integer amounts, first absorbs remainder
                                var total_service = (loan_amount / 100) * pf_interest_rate;
                                var service_per_install = Math.floor(total_service / parseInt(pf_extra_installment));
                                var service_remainder = Math.round((total_service % parseInt(pf_extra_installment)) * 100) / 100;

                                for (let i = 0; i < parseInt(pf_extra_installment); i++)
                                {
                                    all_amounts.push(i === 0 ? service_per_install + service_remainder : service_per_install);
                                }
                           
                                // console.log("1393");  
                                // console.log(govt_interest_amount);
                           }
                           else if(pf_loan_installment_type == 'govt_interest')
                           {

                            //    var govt_interest_amount = (loan_amount/100)*pf_interest_rate;


                            //    for (let i = 0; i < old_loan_tenure; i++)
                            //    {
                            //        all_amounts.push(frac_month_amount);
                            //    }

                            //    for (let i = 0; i < pf_extra_installment; i++)
                            //    {
                            //        all_amounts.push(govt_interest_amount);
                            //    }

                                var govt_interest_amount = (loan_amount/100)*pf_interest_rate;

                               // Principal: integer amounts, first absorbs remainder
                               var principal_per_install = Math.floor(loan_amount / old_loan_tenure);
                               var principal_remainder = loan_amount % old_loan_tenure;

                               for (let i = 0; i < old_loan_tenure; i++)
                               {
                                   all_amounts.push(i === 0 ? principal_per_install + principal_remainder : principal_per_install);
                               }

                               for (let i = 0; i < pf_extra_installment; i++)
                               {
                                   all_amounts.push(govt_interest_amount);
                               }
                               
                           }
                           else if(pf_loan_installment_type == 'fixed_interest')
                           {

                                //    var govt_interest_amount = (loan_amount/100)*pf_interest_rate;

                                //    var total_interest = (govt_interest_amount/12)*old_loan_tenure;

                                //    var interest_amount = ((total_interest/100)*100)/old_loan_tenure;
                                
                                //    interest_amount = Math.round(interest_amount  * 100) / 100;

                                //    var ins_amount = frac_month_amount + interest_amount;
                                //    ins_amount = Math.round(ins_amount  * 100) / 100;

                                //    for (let i = 0; i < old_loan_tenure; i++)
                                //    {
                                //        all_amounts.push(ins_amount); 
                                //    }

                                // Total repayable = principal + flat interest
                                // var total_repayable = loan_amount + (loan_amount * pf_interest_rate / 100);
                                var loan_amount_fi = parseFloat(loan_amount);
                                var total_repayable = loan_amount_fi + (loan_amount_fi * pf_interest_rate / 100);

                                var mod_amount = total_repayable % old_loan_tenure;
                                var adjusted_total = total_repayable - mod_amount;
                                var ins_amount = adjusted_total / old_loan_tenure;

                                for (let i = 0; i < old_loan_tenure; i++)
                                {
                                    all_amounts.push(ins_amount);
                                }
                                // First installment absorbs the remainder
                                // all_amounts[all_amounts.length - old_loan_tenure] += mod_amount;
                                all_amounts[all_amounts.length - old_loan_tenure] = parseFloat(all_amounts[all_amounts.length - old_loan_tenure]) + mod_amount;

                               
                           }
                           else if(pf_loan_installment_type == 'extra_installment_limit')
                           {
                                var company_pf_interest_rate = parseFloat(this.pf_settings.pf_interest_rate.opt_value);

                                var principal_per_install = Math.floor(loan_amount / old_loan_tenure);
                                var principal_remainder   = loan_amount % old_loan_tenure;

                                for (let i = 0; i < old_loan_tenure; i++)
                                {
                                    all_amounts.push(i === 0 ? principal_per_install + principal_remainder : principal_per_install);
                                }

                                // var total_service       = (loan_amount / 100) * company_pf_interest_rate;
                                // var service_per_install = Math.floor(total_service / parseInt(pf_extra_installment));
                                // var service_remainder   = Math.round((total_service % parseInt(pf_extra_installment)) * 100) / 100;

                                // for (let i = 0; i < parseInt(pf_extra_installment); i++)
                                // {
                                //     all_amounts.push(i === 0 ? service_per_install + service_remainder : service_per_install);
                                // }

                                // interest on one installment, same amount for all service charge installments
                                var service_per_install = Math.round((loan_amount / 100) * company_pf_interest_rate * 100) / 100;

                                for (let i = 0; i < parseInt(pf_extra_installment); i++)
                                {
                                    all_amounts.push(service_per_install);
                                }
                            }
                       }

                       if(all_amounts.length==loan_tenure)
                       {
                           var ct = 0;
                           for (let i = 0; i < loan_tenure;i++)
                           {
                               if(all_amounts[i]<=0)
                               {
                                   ct++;
                                   continue;
                               }

                            //    installments.push({month: all_months[i],amount:all_amounts[i]});
                            var pf_extra = parseInt(pf_extra_installment);
                            var is_service_charge = false;

                            if (pf_loan_installment_type == 'plus_one' || pf_loan_installment_type == 'plus_one_fixed' || pf_loan_installment_type == 'govt_interest' || pf_loan_installment_type == 'extra_installment_limit') {
                                is_service_charge = (i >= old_loan_tenure);
                            } else if (pf_loan_installment_type == 'fixed_interest') {
                                // is_service_charge = (i === old_loan_tenure - 1);
                            }
                            // no_interest: is_service_charge stays false

                            installments.push({month: all_months[i],amount: all_amounts[i],service_charge: is_service_charge});
                               ct++;
                           }
                       }
                       if(loan_tenure==ct)
                       {
                           if(installments.length!=loan_tenure)
                           {
                               if(installments.length==0 && this.edit_form)
                               {
                                   this.fdata.remaining_tenure = 0;
                               }
                               else if(!this.edit_form)
                               {
                                   this.fdata.loan_tenure = installments.length;
                               }
                               else if(this.edit_form)
                               {
                                   this.fdata.remaining_tenure = installments.length;
                               }
                           }


                           if(installments.length>0)
                           {
                               for(let i = 0; i<installments.length; i++)
                               {
                                   installments[i].amount = installments[i].amount;
                               }

                           }
                           
                           this.loan_installments = installments;
                        }

                        // console.log('all_amounts');
                        // console.log(all_amounts);
                   }

                } 


                // console.log('loan_installments getInstallments 2 '+ this.loan_installments.length);

                
           },
           getAvailableMonths(date)
           {
               
               if(!this.edit_form)
               {
                   
                   var m_names = ['January', 'February', 'March', 
                               'April', 'May', 'June', 'July', 
                               'August', 'September', 'October', 'November', 'December'];

                   /** Get Last Payrun Date **/
                   var last_payrun_month_2 = this.last_payrun_month;
                   const str_month_arr_2 = last_payrun_month_2.split("-");
                   var payrun_year   = parseInt(str_month_arr_2[1]);
                   var p_month  = str_month_arr_2[0]; 
                   var payrun_month = m_names.indexOf(p_month);
                   var dt1   = 1;
                   const payrun_date = new Date(payrun_year,payrun_month,dt1);
                   payrun_date.setMonth(payrun_date.getMonth()+1);
                   /****/
                   //this.fdata.deduction_start_month = null;
                   var yr1   = parseInt(date.substring(0,4));
                   var mon1  = parseInt(date.substring(5,8)); 
                   var dt1   = parseInt(date.substring(8,10));
                   var all_months = [];
                   
                
                   all_months.push({value: null,text: "Select..."}); 
                   let mt =0;
                   for (let i = 1; i <= 24;) 
                   { 
                       var d = new Date(yr1, mon1-1, dt1);
                       if(d.getDate()>27)
                       {
                           d.setDate(d.getDate() - 5);
                       }
                       d.setMonth(d.getMonth() + mt);

                       if(d.getTime() >= payrun_date.getTime())
                       {
                           var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();
                           all_months.push({value: fullText,text:fullText});
                           i++;
                       
                       }
                       
                       mt++;
                 
                   }
                   
                //    console.log(this.fdata.deduction_start_month);


                   if(all_months.length>=24)
                   {
                       this.m_lists =  all_months;
                       this.fdata.deduction_start_month = this.m_lists[3].value;
                       this.deduction_start = false;

                    //    console.log(this.fdata.deduction_start_month);
                   }
               }
               else
               {
                

                    let formData = new FormData();
                    formData.append('employee_id',this.employee_id);
                    formData.append('effective_date',date);

                    // Start: Rejwan: 17-02-2026(1) Front Routes
                    let url = '';
                    if(this.is_self == 1)
                        url = this.$api_url_front+'/self/pf/get-last-payrun';
                    else
                        url = this.$api_url_front+'/pf/get-last-payrun';
                    // End: Rejwan: 17-02-2026(1) Front Routes

                    // axios.post(this.$api_url+'/pf/get-last-payrun', formData) // Start: Rejwan: 09-02-2026 Front Routes
                    axios.post(url, formData) // Start: Rejwan: 17-02-2026(1) Front Routes
                    .then(function (response)
                    {

                       var m_names = ['January', 'February', 'March', 
                               'April', 'May', 'June', 'July', 
                               'August', 'September', 'October', 'November', 'December'];
                       /** Get Last Payrun Date **/
                       this.last_payrun_month = response.data;
                       var last_payrun_month_2 = this.last_payrun_month;
                       const str_month_arr_2 = last_payrun_month_2.split("-");
                       var payrun_year   = parseInt(str_month_arr_2[1]);
                       var p_month  = str_month_arr_2[0]; 
                       var payrun_month = m_names.indexOf(p_month);
                       var dt1   = 1;
                       var payrun_date = new Date(payrun_year,payrun_month,dt1);
                       payrun_date.setMonth(payrun_date.getMonth()+1);

                       
                       this.date_min = payrun_date;

                       var yr1   = parseInt(date.substring(0,4));
                       var mon1  = parseInt(date.substring(5,8)); 
                       var dt1   = parseInt(date.substring(8,10));
                       var all_months = [];
                       var not_avail = 1;
                       var first_full = '';


                       var selected_date = new Date(yr1, mon1-1, dt1);

                       var date_check = Date.parse(payrun_date) > Date.parse(selected_date);

                       
                    //    if(date_check)
                    //    {
                    //        this.fdata.effective_date_of_loan = '';
                    //        this.fdata.deduction_start_month = '';
                           
                    //    }


                       all_months.push({value: null,text: "Select..."}); 
                       let mt =0;
                       for (let i = 1; i <= 24;) 
                       { 
                           var d = new Date(yr1, mon1-1, dt1);
                           if(d.getDate()>27)
                           {
                               d.setDate(d.getDate() - 5);
                           }
                           d.setMonth(d.getMonth() + mt);

                           if(d.getTime() >= payrun_date.getTime())
                           {
                               var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();

                               if(this.fdata.deduction_start_month==fullText)
                               {
                                   not_avail = 0;
                               }
                               if(i==1)
                               {
                                   first_full = fullText;
                                   //this.getInstallments();
                               } 
                               all_months.push({value: fullText,text:fullText});
                               i++;
                           
                           }
                           
                           mt++;
                       }
                       if(not_avail && date_check==false)
                       {
                           this.fdata.deduction_start_month = first_full;
                       }
                       
                       if(all_months.length>=24)
                       {
                           this.m_lists =  all_months;
                           this.deduction_start = false;
                       }

                   }.bind(this));
               }

           },  
            getNextAvailableMonths()
            {

                
                var paid_amount = this.toMoney(this.fdata.paid_amount);
                let formData = new FormData();
                formData.append('employee_id',this.employee_id);

                // Start: Rejwan: 17-02-2026(1) Front Routes
                let url = '';
                if(this.is_self == 1)
                    url = this.$api_url_front+'/self/pf/get-last-payrun';
                else
                    url = this.$api_url_front+'/pf/get-last-payrun';
                // End: Rejwan: 17-02-2026(1) Front Routes
                
                // axios.post(this.$api_url+'/pf/get-last-payrun', formData) // Start: Rejwan: 09-02-2026 Front Routes
                axios.post(url, formData) // Start: Rejwan: 17-02-2026(1) Front Routes
                .then(function (response)
                {

                    this.last_payrun_month = response.data;
                    if(this.edit_form)
                    { 
                        this.deduction_start_month_title = 'Next Deduction Month'; 

                        var m_names = ['January', 'February', 'March', 
                                'April', 'May', 'June', 'July', 
                                'August', 'September', 'October', 'November', 'December'];
                        var all_months = [];
        
                        if(paid_amount==0)
                        {
                            if(paid_amount==0)
                            {
                                var date  = this.fdata.effective_date_of_loan;
                                var yr1   = parseInt(date.substring(0,4));
                                var mon1  = parseInt(date.substring(5,8)); 
                                mon1 = mon1-1;
                                var dt1   = parseInt(date.substring(8,10));
                                var d = new Date(yr1, mon1, dt1);
                                var last_payrun_month_2 = this.last_payrun_month;
                                const str_month_arr_2 = last_payrun_month_2.split("-");
                                var payrun_year   = parseInt(str_month_arr_2[1]);
                                var p_month  = str_month_arr_2[0]; 
                                var payrun_month = m_names.indexOf(p_month);
                                var dt2   = 1;
                                const payrun_date = new Date(payrun_year,payrun_month,dt2);
                                payrun_date.setMonth(payrun_date.getMonth()+1);
                                var date_check = Date.parse(payrun_date) > Date.parse(d);
                                var no_install = true;
                                var p_date = payrun_date;
                                
                                // Ali test disable 11-5-2023

                                // if(date_check)
                                // {
                                //     this.fdata.effective_date_of_loan = '';
                                //     this.fdata.deduction_start_month = '';
                                //     this.fdata.next_installment_month = null;
                                //     this.m_list_2 = [];
                                    
                                // }

                            
                        
                            }
                        }
                        else
                        {


                            var start_month = this.fdata.next_installment_month;
                            const str_month_arr = start_month.split("-");
                            var yr1   = parseInt(str_month_arr[1]);
                            var mt  = str_month_arr[0]; 
                            var mon1 = m_names.indexOf(mt);
                            var dt1   = 1;
                            var current_date = new Date();
                            var d1 = new Date(yr1, mon1);
                            var d2 = new Date(current_date.getFullYear(), current_date.getMonth());    // 02/2014
                            var date_check = Date.parse(d2) > Date.parse(d1);
                            var no_install = false;
                            
                            if(this.fdata.remaining_tenure == this.fdata.loan_tenure)
                            {
                                no_install = true;
                                
                            }


                            // console.log('no_install no_install ');
                            // console.log(no_install);
                            // Ali test disable 11-5-2023
                            if(date_check==true && no_install == true)
                            {

                                this.loan_installments = [];
                                this.fdata.installments = [];
                                for (let i = 0; i < 24;)  
                                { 
                                    var d = new Date();
                                    if(d.getDate()>27)
                                    {
                                        d.setDate(d.getDate() - 5);
                                    }
                                    d.setMonth(d.getMonth() + i);
                                    var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();
                                    if(i==0)
                                    {
                                        this.fdata.next_installment_month = fullText;
                                        //this.getInstallments();
                                    } 
                                    all_months.push({value: fullText,text:fullText});
                                    i++;
                                }
                                
                            }
                            
                            else
                            {
                                for (let i = 0; i < 24;)  
                                { 
                                    var d = new Date(yr1, mon1, dt1);
                                    if(d.getDate()>27)
                                    {
                                        d.setDate(d.getDate() - 5);
                                    }
                                    d.setMonth(d.getMonth() + i);
                                    var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();

                                    all_months.push({value: fullText,text:fullText});
                                    i++;
                                }

                            }

                            
                            
                            if(all_months.length>=24)
                            {
                                this.m_list_2 =  all_months;
                            }

                            
                        }
                    }
                }.bind(this));


               

            },
           
           editLoanInfo:function(x,type)
           {        
               
               if(!this.checkNet()) return false;

                   if(type==0)
                   {
                       this.resetForm();
                       this.is_custom_payment =0;
                   }
                   if(type==1)
                   {
                       this.resetForm();
                       this.is_custom_payment =1;
                   }


                   let currentObj = this;
                //    axios.get(this.$api_url+'/pf/settings').then(function (response) { // Start: Rejwan: 09-02-2026 Front Routes
                   axios.get(this.$api_url_front+'/pf/settings').then(function (response) { // Start: Rejwan: 09-02-2026 Front Routes
                       currentObj.pf_settings = response.data.data;

                       
                       currentObj.default_tenure = currentObj.pf_settings.pf_loan_max_installment_limit.opt_value;
                       currentObj.tenure_list = Array.from({length: currentObj.default_tenure }, (_, i) => i + 1);
                       currentObj.fdata.loan_tenure = currentObj.pf_settings.pf_loan_max_installment_limit.opt_value;
                       
                       // Start: Rejwan: 17-02-2026(1) Front Routes
                        let url = '';
                        if(currentObj.is_self == 1)
                            url = currentObj.$api_url_front+'/self/pf/loan/edit';
                        else
                            url = currentObj.$api_url_front+'/pf/loan/edit';
                        // End: Rejwan: 17-02-2026(1) Front Routes

                    //    axios.get(currentObj.$api_url+'/pf/loan/edit' , { // Start: Rejwan: 09-02-2026 Front Routes
                       axios.get(url , { // Start: Rejwan: 17-02-2026(1) Front Routes
                       params: {
                           id: x 
                       }
                       })
                       .then(function(response){
                           currentObj.edit_change_click = false;
                           currentObj.fdata = response.data;
                           currentObj.company_id = currentObj.fdata.company_id;
                           currentObj.thread_key += 1;
   
                           
                           /***** */
                           if(currentObj.fdata.loan_amount != currentObj.fdata.remaining_amount)
                           {
                               currentObj.loan_status = [{ value: null, text: "Select..." },{ value: "2", text: "Approve" },{ value: "3", text: "Pause/Stop" }];
                           }

                           currentObj.disableamount = true;
                           if(currentObj.fdata.status==1)
                           {
                               currentObj.loan_status =  [{ value: null, text: "Select..." },{ value: "0", text: "Decline" },{ value: "1", text: "Applied" },{ value: "2", text: "Approve" }];
                               currentObj.disableamount = false;
                           
                           }

                           if(currentObj.fdata.company_loan_id == 'N/A')
                           {
                                currentObj.fdata.company_loan_id = '';
                           }

                           currentObj.fdata.loan_amount =  currentObj.formatMoney(currentObj.fdata.loan_amount);
                           currentObj.fdata.paid_amount =  currentObj.formatMoney(currentObj.fdata.paid_amount);
                           currentObj.remaining_amount_money  = currentObj.fdata.remaining_amount;
                           currentObj.fdata.remaining_amount =  currentObj.formatMoney(currentObj.fdata.remaining_amount);

                           /***** */
                           currentObj.fdata.custom_amount = 0;
                           currentObj.custom_amount = 0;
                           currentObj.loan_installments = currentObj.fdata.installments; 

                           console.log('loan_installments installments-15');
                           console.log(currentObj.fdata.installments); 
                           
                           console.log('loan_installments editLoanInfo-15'); 
                           console.log(currentObj.loan_installments.length);


                           if(currentObj.loan_installments.length>0) 
                           {
                               for(let i = 0; i < currentObj.loan_installments.length; i++)
                               {
                                    var amount = currentObj.loan_installments[i].amount;
                                    var sc = currentObj.loan_installments[i].service_charge;  // Re-stamp service_charge flag after loading from backend
                                    currentObj.loan_installments[i].amount = currentObj.formatMoney(currentObj.loan_installments[i].amount);
                                    currentObj.loan_installments[i].service_charge = (sc === 1 || sc === '1');  // Re-stamp service_charge flag after loading from backend
                               }
                           }

                           currentObj.loan_type = currentObj.fdata.loan_type;  
                           // this.custom_tenure_limit = this.fdata.remaining_tenure
                           currentObj.custom_tenure_limit = 300;
                           currentObj.edit_form = 1;
                           currentObj.successmsg = null;
                           currentObj.disableme = true;
                           
                           if(currentObj.fdata.paid_amount ==0)
                           {
                               currentObj.disableme = false;
                           }
                           
                           currentObj.disable_submit =false;
                           currentObj.disable_submit_all =false;
                           currentObj.disable_submit_new =false;
                           currentObj.disable_submit_amount =false;
                           

                           currentObj.change_tenure_trigger = 0,
                           currentObj.change_deduction_trigger = 0,
                           currentObj.pf_loan_form_disable=false;
                           currentObj.pf_contribution = 0,
                           currentObj.employee_id = currentObj.fdata.employee_id;  

                        //    console.log('loan_installments editLoanInfo-2');
                        //    console.log(currentObj.loan_installments.length);

                           currentObj.getBankInfo(currentObj.employee_id);
                           currentObj.getLastPayrun(currentObj.employee_id);
                           currentObj.getAvailablePf();
                           currentObj.getInstallments();  
                           currentObj.getAvailableMonths(currentObj.fdata.effective_date_of_loan);
                           currentObj.getNextAvailableMonths();
                           currentObj.getEmployeeInfo(currentObj.employee_id); // Rejwan: 24-12-2025

                        //    console.log('loan_installments editLoanInfo-3');
                        //    console.log(currentObj.loan_installments.length);

                           currentObj.loan_tenure_new = currentObj.fdata.remaining_tenure;
                           currentObj.deduction_start_month_title = 'Advance Deduction Start Month'; 
                           currentObj.tenure_title = 'Remaining Repayment Tenure'; 

                           var paid_amount = currentObj.toMoney(currentObj.fdata.paid_amount);

                           if(paid_amount > 0 || currentObj.is_custom_payment==1)
                           {
                               currentObj.no_installment = false;
                               currentObj.disableamount = true;

                               currentObj.hide_submit_button = true; 
                           }

                           if(currentObj.is_status != 0)
                           {
                               currentObj.fdata.status = currentObj.is_status;
                           }
                           
                           let c = currentObj.fdata.loan_tenure + ' Month(s)';
                           currentObj.loan_tenure_label = c; 
                           
                           //currentObj.showoverlaymodal = false;

                           currentObj.old_repayment_tenure = currentObj.fdata.loan_tenure + currentObj.fdata.interest_tenure;
                           currentObj.old_loan_amount = currentObj.toMoney(currentObj.fdata.loan_amount);
                           currentObj.fdata.confirm_terms = 1;

                           if(currentObj.approvals == 1)
                           {
                            currentObj.disableme = true;
                            currentObj.disableamount = true;
                           }

                       }.bind(this)).catch(function (error){alert(error)});
                    
                           
                   })  
                   .catch(function (error) {
                   console.log(error);
                   });
               
           },   
           getApplicationSettings(id)
           {
               if(!this.checkNet()) return false;
               let currentObj = this; 
               
               // Start: Rejwan: 17-02-2026(1) Front Routes
                let url = '';
                if(this.is_self == 1)
                    url = this.$api_url_front+'/self/approver/application-data';
                else
                    url = this.$api_url_front+'/approver/application-data';
                // End: Rejwan: 17-02-2026(1) Front Routes

            //    axios.get(this.$api_url+'/approver/application-data', { // Start: Rejwan: 09-02-2026 Front Routes
               axios.get(url, { // Start: Rejwan: 17-02-2026(1) Front Routes
                   params: {
                       module: 7,
                       ref_id: id
                   }
               }).then(function(response){
                   this.approver_settings = response.data;
                   this.loan_approver_app_id = this.approver_settings.application_id;

               }.bind(this)).catch(function (error){currentObj.serverError(error);});

           },

           getApplicationApprovals(id)
           {
               if(!this.checkNet()) return false;
               let currentObj = this; 
               
               // Start: Rejwan: 17-02-2026(1) Front Routes
                let url = '';
                if(this.is_self == 1)
                    url = this.$api_url_front+'/self/approver/application-approval';
                else
                    url = this.$api_url_front+'/approver/application-approval';
                // End: Rejwan: 17-02-2026(1) Front Routes

            //    axios.get(this.$api_url+'/approver/application-approval', { // Start: Rejwan: 09-02-2026 Front Routes
               axios.get(url, { // Start: Rejwan: 17-02-2026(1) Front Routes
                   params: {
                       module: 7,
                       ref_id: id
                   }
               }).then(function(response){
                let application_data = response.data;
                    console.log(response);
                    if(application_data.approvals == 1)
                    {
                        currentObj.approvals = 1;
                    }
                    
               }.bind(this)).catch(function (error){currentObj.serverError(error);});

           },
           showBankDetails()
           {
            this.$bvModal.show('bv-modal-bank');     
           },
           getBankData()
           {
             this.$bvModal.hide('bv-modal-bank');     
             
           },
           onSubmit(e) 
           {   
               if(!this.checkNet()) return false;
               
                this.$validator.validateAll().then(result => {
                   if (!result) {
                       return;
                   }

                let current_level = this.approver_settings.application_level +1;
                let depth = this.approver_settings.depth;
                // console.log('current_level '+ current_level);
                // console.log('depth '+ depth);
                // console.log('application_status '+ this.loan_approval_status); 
                if(current_level == depth && this.loan_approval_status == 1 && this.$site_options && this.$site_options['pf_advance_awaiting_disbursement'] == 1)
                {
                    
                    if(this.bdata.id == undefined)
                    {
                        this.$bvToast.toast('Please provide Bank Information', {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                            }); 
                            this.showoverlaymodal = false;
                        return;
                    }
                    
                    
                }

                if(this.fdata.confirm_terms == 0)
                {
                    this.$bvToast.toast('Please check the rquired checkbox', {
                        title: `Error`,
                        variant: 'danger',
                        solid: true
                    });  
                    return;
                }
                   
                   e.preventDefault();  
                   let currentObj = this;
                   currentObj.errormsg = '';
                   this.showoverlaymodal = true;
                   let formData = new FormData();
                   this.fdata.installments = [];
                   /***** */
                   var pattern = /^(0|[1-9][0-9]{0,2}(?:(,[0-9]{3})*|[0-9]*))(\.[0-9]+){0,1}$/;
                   //if(pattern.test(this.fdata.loan_amount ))
                   if(1)
                   {
                       this.fdata.loan_amount =  this.toMoney(this.fdata.loan_amount);
                       this.fdata.loan_amount =  Math.round(this.fdata.loan_amount  * 100) / 100;
                   }
                   else
                   {
                       alert("Amount is invalid");
                       return 0;
                   }
                   
                   this.fdata.paid_amount =  this.toMoney(this.fdata.paid_amount);
                   this.fdata.paid_amount =  Math.round(this.fdata.paid_amount  * 100) / 100;
                   this.fdata.remaining_amount =  this.toMoney(this.fdata.remaining_amount);
                   this.fdata.remaining_amount =  Math.round(this.fdata.remaining_amount  * 100) / 100;
                   if(this.fdata.remaining_tenure == this.fdata.loan_tenure)
                   {
                       this.fdata.deduction_start_month = this.fdata.next_installment_month;
                   }
                   

                   if(this.loan_installments.length)
                   { 
                      
                       var installs = 0;
                       for(let i = 0; i<this.loan_installments.length; i++)
                       {
                           installs = this.toMoney(this.loan_installments[i].amount);
                           installs =  Math.round(installs  * 100) / 100;
                           this.loan_installments[i].amount = installs;
                       }
                       this.fdata.installments = JSON.stringify(this.loan_installments);
                       this.fdata.remaining_tenure = this.loan_installments.length;
                   }

                   this.fdata.interest_type = this.pf_settings.pf_loan_installment.opt_value;
                //    this.fdata.interest_tenure =  this.pf_settings.pf_extra_installment.opt_value;
                //    Start: Rejwan: 24-08-2026
                // if(this.pf_settings.pf_loan_installment.opt_value == 'extra_installment_limit')
                    // {
                    //     this.fdata.interest_tenure = this.loan_installments.filter(function(i) { return i.service_charge === true; }).length;
                    // }
                    // else 
                    // {
                    //     this.fdata.interest_tenure =  this.pf_settings.pf_extra_installment.opt_value;
                    // }
                    const interestTypes = ['plus_one', 'plus_one_fixed', 'govt_interest', 'extra_installment_limit'];
                    const installmentType = this.pf_settings.pf_loan_installment.opt_value;

                    if (installmentType == 'extra_installment_limit') {
                        this.fdata.interest_tenure = this.loan_installments.filter(i => i.service_charge === true).length;
                    } else if (interestTypes.includes(installmentType)) {
                        this.fdata.interest_tenure = this.pf_settings.pf_extra_installment.opt_value;
                    } else {
                        this.fdata.interest_tenure = 0;
                    }
                    //    End: Rejwan: 24-08-2026
                   this.fdata.amount_with_interest =  this.amount_with_interest;
               
                   /**** */
                   for (let [key, value] of Object.entries(this.fdata)) 
                   {                    
                       var nm = `${key}`;
                       var fval = `${value}`;
                       formData.append(nm, fval);                    
                   } 


                //    if(this.approver_settings.show == 1)
                //    {
                       formData.append('approval_status', this.loan_approval_status);  
                       formData.append('approval_comment', this.approval_comment); 
                       

                       for (let [key, value] of Object.entries(this.approver_settings)) 
                       {                    
                           var nm = `${'approval_'+key}`;
                           var fval = `${value}`;
                           formData.append(nm, fval);                    
                       } 

                   
                    if(this.loan_id ==  0)
                    {
                        for (let [key, value] of Object.entries(this.bank_data_new)) 
                       {                    
                           var nm = `${'bank_'+key}`;
                           var fval = `${value}`;
                           formData.append(nm, fval);                    
                       }  

                       if(this.upload_file.length > 0)
                       {
                            this.upload_file.forEach(file => {
                                formData.append("upload_file[]", file)
                            })
                       }

                    }
                    
                    //formData.append('approver_settings', this.approver_settings); 
                    //    } 
                 
                  
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                   this.showoverlay = true;
                   let url = '';
                    // Start: Rejwan: 13-01-2026 Reject Loan
                    if(this.loan_approval_status == 3) {
                        // url = this.$api_url+'/pf/loan/reject'; // Start: Rejwan: 09-02-2026 Front Routes
                        url = this.$api_url_front+'/pf/loan/reject'; // Start: Rejwan: 09-02-2026 Front Routes
                    } else {
                        // url = this.$api_url+'/pf/loan/save'; // Start: Rejwan: 09-02-2026 Front Routes
                        // Start: Rejwan: 17-02-2026(1) Front Routes
                        if(this.is_self == 1)
                            url = this.$api_url_front+'/self/pf/loan/save';
                        else
                            url = this.$api_url_front+'/pf/loan/save';
                        // End: Rejwan: 17-02-2026(1) Front Routes
                    }
                    // End: Rejwan: 13-01-2026 Reject Loan
                    // axios.post(this.$api_url+'/pf/loan/save', formData,config) //  Rejwan: 13-01-2026 Reject Loan
                   axios.post(url, formData,config) //  Rejwan: 13-01-2026 Reject Loan
                    .then(function (response) 
                    {
                        
                        this.$bvToast.toast("Saved!", {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });
                        var data = this.fdata.employee_id;
                        this.$emit('childToParent'); 
                        //this.resetForm();
                        this.showoverlay = false;
                        this.showoverlaymodal = false;
                        
                    }.bind(this))
                    .catch(function (error) 
                    {           
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;                                    
                        for (var data in currentObj.errormsg)
                        {
                            var msg = currentObj.errormsg[data];
                            currentObj.$bvToast.toast(msg, {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                            }); 
                            currentObj.$validator.reset(); 
                        } 
                    });
               });
           },
           //    Start: Rejwan: 01-12-2025
           getEmployeeInfo(employee_id) {
                let currentObj = this; 
               
                // Start: Rejwan: 24-12-2025
                let formData = new FormData();
                formData.append('employee_id', employee_id);
                // End: Rejwan: 24-12-2025

                // Start: Rejwan: 17-02-2026(1) Front Routes
                let url = '';
                if(this.is_self == 1)
                    url = this.$api_url_front+'/self/pf/employee-info';
                else
                    url = this.$api_url_front+'/pf/employee-info';
                // End: Rejwan: 17-02-2026(1) Front Routes

            //    axios.post(this.$api_url + '/pf/employee-info', formData) // Start: Rejwan: 09-02-2026 Front Routes
               axios.post(url, formData) // Start: Rejwan: 17-02-2026(1) Front Routes
                .then((response) => {
                    this.employee_details = response.data;
                })
                .catch((error) => {
                    this.serverError(error);
                });
           }
           //    End: Rejwan: 01-12-2025
          
       }, 
       computed:
       {
           checkPFLimit()
           {
               


               let loan_mon = this.toMoney(this.fdata.loan_amount);

              

               if(loan_mon > this.pf_contribution)
               {
                   this.pf_loan_form_disable =true;
                //    this.loan_amount_disable_text = 'The Advance Amount must be less or equal to the total provident fund balance';
                   this.loan_amount_disable_text = 'The advance amount must be less or equal to the eligible balance for advance';
                   if(this.edit_form==1 && this.fdata.status != 1)
                   {
                       this.pf_loan_form_disable =false;
                   }
               }
               else
               {
                   this.pf_loan_form_disable =false;

                   if(loan_mon % 1 != 0 || loan_mon < 0)
                    {
                        if(loan_mon < 0)
                        {
                            this.pf_loan_form_disable =true;
                            this.loan_amount_disable_text = 'The Advance Amount cannot be negetive value';
                        }
                        else
                        {
                            this.pf_loan_form_disable =true;
                            this.loan_amount_disable_text = 'The Advance Amount cannot have decimal places';
                        }
                            
                             
                    }
                    else
                    {
                            this.loan_amount_disable_text = '';
                            this.pf_loan_form_disable =false;
                    }
               }

              
           },
           checkInstallmentamount() 
           {
            //    console.log('loan_installments checkInstallmentamount');
            //    console.log(this.loan_installments);
               
               var ct_amount = 0.00; 
           
               if(this.fdata.loan_tenure > 0 && this.fdata.deduction_start_month != null && this.fdata.loan_amount != '' && this.fdata.effective_date_of_loan != '' && (ct_amount >= 0))
               {
                
                   this.getInstallments();
               }  
               else 
               { 
                
                   this.showInstallment = false; 
                   this.loan_installments = [];
               }

           },
           onInstallmentChange()
           {
               this.show_extra_installment_info = false;
               
            //    console.log('loan_installments onInstallmentChange  '+ this.loan_installments.length);

               if(this.loan_installments.length>0)
               { 
                   
                   var installment_total = 0;
                   var install_money = 0;
                   var interest_tenure = 0;
                   var reguler_tenure = this.loan_installments.length - interest_tenure;
                   var number = 0;
                   for(let i = 0; i< this.loan_installments.length; i++)
                   {
                        //alert(this.loan_installments[i].amount);
                       install_money = this.toMoney(this.loan_installments[i].amount);
                       number = Math.round(install_money * 100) / 100;
                       installment_total  = installment_total + number;
                   }
                   installment_total = Math.round(installment_total * 100) / 100;
                   var payable_amount = 0;


                   var pf_loan_installment_type = this.pf_settings.pf_loan_installment.opt_value;
                   var pf_extra_installment = this.pf_settings.pf_extra_installment.opt_value;
                   
                   if(pf_loan_installment_type != 'plus_one' && pf_loan_installment_type != 'plus_one_fixed' && pf_loan_installment_type != 'govt_interest' && pf_loan_installment_type != 'fixed_interest' && pf_loan_installment_type != 'extra_installment_limit')
                   {
                       if(this.edit_form) 
                       {
                           if(this.disableamount == false)
                           { 
                               payable_amount = this.toMoney(this.fdata.loan_amount);
                               payable_amount = Math.round(payable_amount * 100) / 100;
                           }
                           else
                           {
                               payable_amount = this.toMoney(this.fdata.remaining_amount);
                               payable_amount = Math.round(payable_amount * 100) / 100;
                           }
                           
                       }
                      
                       if(!this.edit_form)
                       {
                           payable_amount = this.toMoney(this.fdata.loan_amount);
                           payable_amount = Math.round(payable_amount * 100) / 100;
                       }
                   }
                   else
                   {
                    
                    if(1)
                    {
                        var pf_extra_installment = this.pf_settings.pf_extra_installment.opt_value;
                        let fractioned_payable_amount = 0;
                        
                        // Start: Rejwan: 23-06-2026
                        // if(pf_loan_installment_type == 'plus_one')
                        // {
                        //         var loan_amount = this.toMoney(this.fdata.loan_amount);
                        //         loan_amount = Math.round( loan_amount * 100) / 100;
                        //         var interest_tenure = parseInt(pf_extra_installment);

                        //         if(this.fdata.status == 2)
                        //         {
                        //             var reguler_tenure = this.fdata.loan_tenure;
                        //         }
                        //         else
                        //         {
                        //             var reguler_tenure = this.loan_installments.length - interest_tenure;
                        //         }
                                
                        //         var frac_month_amount =  loan_amount/reguler_tenure;
                        //         frac_month_amount = Math.round(frac_month_amount);
                        //         var extra_amount = frac_month_amount * interest_tenure;
                        //         let rounded_frac_month_amount = Math.round(frac_month_amount);
                        //         let total_installment_number  = reguler_tenure + interest_tenure;
                        //         let rounded_payable_amount = rounded_frac_month_amount * total_installment_number;
                        //         // fractioned_payable_amount = rounded_payable_amount - loan_amount - frac_month_amount; 
                        //         fractioned_payable_amount = rounded_payable_amount - loan_amount - (frac_month_amount * parseInt(pf_extra_installment));


                        //         loan_amount = rounded_payable_amount - fractioned_payable_amount - extra_amount;


                                
                        //         // console.log('interest_tenure');
                        //         // console.log(interest_tenure);
                        //         // console.log('reguler_tenure');
                        //         // console.log(reguler_tenure);
                        //         // console.log('loan_amount');
                        //         // console.log(loan_amount);
                        //         // console.log('extra_amount');
                        //         // console.log(extra_amount);
                            
                        // }
                        if(pf_loan_installment_type == 'plus_one')
                        {
                            var loan_amount = this.toMoney(this.fdata.loan_amount);
                            loan_amount = Math.round( loan_amount * 100) / 100;
                            var interest_tenure = parseInt(pf_extra_installment);

                            if(this.fdata.status == 2 || this.fdata.status == 3)
                            {
                                var reguler_tenure = this.fdata.loan_tenure;
                            }
                            else
                            {
                                var reguler_tenure = this.loan_installments.length - interest_tenure;
                            }

                            // Rejwan: sum the actual service-charge installments so the info text
                            // matches what is shown in the installment table (avoids round/floor drift)
                            var extra_amount = 0;
                            for (var si = 0; si < this.loan_installments.length; si++)
                            {
                                if (this.loan_installments[si].service_charge === true)
                                {
                                    extra_amount += parseFloat(this.toMoney(this.loan_installments[si].amount));
                                }
                            }
                            extra_amount = Math.round(extra_amount * 100) / 100;
                        }
                        // End: Rejwan: 23-06-2026
                        else if(pf_loan_installment_type == 'plus_one_fixed')
                        {
                            
                            console.log(2116);
                            var loan_amount = this.toMoney(this.fdata.loan_amount);
                            loan_amount = Math.round( loan_amount * 100) / 100;
                            var pf_interest_rate = parseFloat(this.pf_settings.pf_interest_rate.opt_value);
                            var extra_amount = (loan_amount/100)*pf_interest_rate;
                            extra_amount = Math.trunc(extra_amount*100)/100;

                            var interest_tenure = parseInt(pf_extra_installment);
                            var reguler_tenure = this.loan_installments.length - interest_tenure;
                            
                        }
                        else if(pf_loan_installment_type == 'govt_interest')
                        {
                            var loan_amount = this.toMoney(this.fdata.loan_amount);
                            loan_amount = Math.round( loan_amount * 100) / 100;
                            var pf_interest_rate = parseFloat(this.pf_settings.pf_interest_rate.opt_value);
                            var extra_amount = (loan_amount/100)*pf_interest_rate;
                            
                            if(this.loan_installments.length >13)
                            {
                                var interest_tenure = 2;
                            }
                            else
                            {
                                var interest_tenure = 1;
                            }
                            extra_amount = extra_amount*interest_tenure;
                            
                            var reguler_tenure = this.loan_installments.length - interest_tenure;
                            
                            
                        }
                        else if(pf_loan_installment_type == 'fixed_interest')
                        {

                            var loan_amount = this.toMoney(this.fdata.loan_amount);
                            loan_amount = Math.round( loan_amount * 100) / 100;
                            var pf_interest_rate = parseFloat(this.pf_settings.pf_interest_rate.opt_value);
                            // var govt_interest_amount = (loan_amount/100)*pf_interest_rate;
                            // var interest_tenure = 0;
                            // var total_interest = (govt_interest_amount/12)*this.loan_installments.length;
                            // var extra_amount = total_interest;
                            var extra_amount = loan_amount * pf_interest_rate / 100;
                            
                        }
                        // else if(pf_loan_installment_type == 'extra_installment_limit')
                        // {
                        //     var loan_amount = this.toMoney(this.fdata.loan_amount);
                        //     loan_amount = Math.round(loan_amount * 100) / 100;
                        //     var company_pf_interest_rate = parseFloat(this.pf_settings.pf_interest_rate.opt_value);
                        //     var extra_amount = (loan_amount / 100) * company_pf_interest_rate;
                        //     extra_amount = Math.trunc(extra_amount * 100) / 100;

                        //     var pf_installment_limit        = parseInt(this.pf_settings.pf_installment_limit.opt_value);
                        //     var pf_extra_installment_val    = parseInt(this.pf_settings.pf_extra_installment.opt_value);
                        //     var pf_extra_after_limit        = parseInt(this.pf_settings.pf_extra_installment_after_limit.opt_value);

                        //     var interest_tenure = (this.loan_installments.length > pf_installment_limit) ? pf_extra_installment_val + pf_extra_after_limit : pf_extra_installment_val;

                        //     var reguler_tenure = this.loan_installments.length - interest_tenure;
                        // }
                        // else if(pf_loan_installment_type == 'extra_installment_limit')
                        // {
                        //     var loan_amount = this.toMoney(this.fdata.loan_amount);
                        //     loan_amount = Math.round(loan_amount * 100) / 100;

                        //     // sum directly from what getInstallments already generated — always accurate
                        //     var extra_amount    = 0;
                        //     var interest_tenure = 0;
                        //     var reguler_tenure  = 0;

                        //     for (var ii = 0; ii < this.loan_installments.length; ii++)
                        //     {
                        //         if (this.loan_installments[ii].service_charge)
                        //         {
                        //             extra_amount += this.toMoney(this.loan_installments[ii].amount);
                        //             interest_tenure++;
                        //         }
                        //         else
                        //         {
                        //             reguler_tenure++;
                        //         }
                        //     }

                        //     extra_amount = Math.round(extra_amount * 100) / 100;
                        // }
                        else if(pf_loan_installment_type == 'extra_installment_limit')
                        {
                            var loan_amount = this.toMoney(this.fdata.loan_amount);
                            loan_amount = Math.round(loan_amount * 100) / 100;

                            var company_pf_interest_rate = parseFloat(this.pf_settings.pf_interest_rate.opt_value);
                            var pf_installment_limit     = parseInt(this.pf_settings.pf_installment_limit.opt_value);
                            var pf_extra_installment_val = parseInt(this.pf_settings.pf_extra_installment.opt_value);
                            var pf_extra_after_limit     = parseInt(this.pf_settings.pf_extra_installment_after_limit.opt_value);

                            // principal tenure = total length minus the base extra installments.
                            // decide the service count from the limit on the principal tenure (same rule as getInstallments)
                            var interest_tenure = ((this.loan_installments.length - pf_extra_installment_val) > pf_installment_limit)
                                                ? pf_extra_installment_val + pf_extra_after_limit
                                                : pf_extra_installment_val;

                            var reguler_tenure = this.loan_installments.length - interest_tenure;

                            // same formula as getInstallments: full loan interest per service installment
                            var service_per_install = Math.round((loan_amount / 100) * company_pf_interest_rate * 100) / 100;
                            var extra_amount = service_per_install * interest_tenure;
                            extra_amount = Math.round(extra_amount * 100) / 100;
                        }


                        this.show_extra_installment_info = true;
                        this.amount_with_interest =  loan_amount + extra_amount;
                        this.extra_amount = extra_amount;

                        if(fractioned_payable_amount > 0)
                        {
                                this.extra_amount = extra_amount - 1;
                        }

                        // this.pf_settings.pf_extra_installment.opt_value =interest_tenure;
                        //    Start: Rejwan: 24-08-2026
                        // if(pf_loan_installment_type != 'extra_installment_limit')
                        // {
                        //     this.pf_settings.pf_extra_installment.opt_value = interest_tenure;
                        // }
                        //    End: Rejwan: 24-08-2026
                        if(this.edit_form)
                        {
                            if(this.disableamount == false)
                            {
                                // here
                                payable_amount = this.amount_with_interest;
                                payable_amount = Math.round(payable_amount * 100) / 100;

                              
                            }
                            else
                            {
                                //payable_amount = this.toMoney(this.fdata.remaining_amount);
                                payable_amount = this.amount_with_interest;
                                payable_amount = Math.round(payable_amount * 100) / 100;
                               
                               
                            }
                            
                        }
                        
                        if(!this.edit_form)
                        {
                            payable_amount = this.toMoney(this.fdata.loan_amount) + extra_amount;
                            payable_amount = Math.round(payable_amount * 100) / 100;

                            // console.log('extra_amount');
                            // console.log(extra_amount);
                            // console.log('payable_amount');
                            // console.log(payable_amount);
                        }
                    }
                       

                   } 
                //    console.log('installment_total');
                //    console.log(installment_total);
                //    console.log('payable_amount');
                //    console.log(payable_amount);

                   if(installment_total != payable_amount)
                   { 
                       var differ = Math.abs(installment_total - payable_amount)
                       
                       if(differ > 5)
                       {
                           this.disable_submit = true;
                           this.remaining_installment_amount = payable_amount -installment_total;
                           if (isNaN(this.remaining_installment_amount)) 
                           {
                                this.remaining_installment_amount =' *Installment amount must be equal to total payable. Installment field contain invalid value';
                           }
                           else
                           {
                               if(this.remaining_installment_amount> 0)
                               {
                                   this.remaining_installment_amount  = this.formatMoney(this.remaining_installment_amount);
                                   this.remaining_installment_amount =' *Installment amount must be equal to total payable. Total Installment amount is '+this.remaining_installment_amount+' less than total payable';
                               }
                               if(this.remaining_installment_amount< 0)
                               {
                                   this.remaining_installment_amount = this.remaining_installment_amount * (-1);
                                   this.remaining_installment_amount  = this.formatMoney(this.remaining_installment_amount);
                                   this.remaining_installment_amount =' *Installment amount must be equal to total payable. Total Installment amount is '+this.remaining_installment_amount+' more than total payable';
                               }
                           }
                       }
                       else
                       {
                           this.disable_submit = false;
                           this.remaining_installment_amount =this.formatMoney(0);
                       }

                   } 
                   else
                   {
                       this.disable_submit = false;
                       this.remaining_installment_amount =this.formatMoney(0);
                   }
               } 

            //    console.log('loan_installments onInstallmentChange 2 '+ this.loan_installments.length);
           },
           checkInput()
           {

               if(this.disable_submit_new || this.disable_submit || this.disable_submit_amount || this.pf_loan_form_disable)
               {
                   this.disable_submit_all = true;
               }
               else
               {
                   this.disable_submit_all = false;
               }
               
           },
           checkName()
           {

                //var pf_reminder_email = this.pf_settings.pf_enable_loan_reminder.opt_value;
                //var pf_application_date = '2023-04-01';
                var pf_application_date = this.fdata.application_date;
                var pf_poke = this.fdata.poke;
                var application_level = this.approver_settings.application_status;

                // if(application_level == 0 && pf_poke == 0 && pf_reminder_email == 1 && pf_application_date != null)
                // {
                //     var current_date = new Date();
                //     var pf_application_date = new Date(pf_application_date);

                //     var millisecondsPerDay = 24 * 60 * 60 * 1000; // Number of milliseconds in a day
                //     var differenceInMilliseconds = current_date.getTime() - pf_application_date.getTime();

                //     if(differenceInMilliseconds > millisecondsPerDay*1)
                //     {
                //         this.show_reminder_button = 1;
                //     }
                //     else
                //     {
                //         this.show_reminder_button = 0;
                //     }
                   
                // }
                // else
                // {

                // }


                if(this.employee_name != '')
                {
                    this.bank_data_new.beneficiary_name = this.employee_name;
                }
                else
                {
                    
                }
           },
           
       },
       created: function()
       {

           this.pf_contribution = 0;
           this.loan_installments = [];
           this.loan_type = 1;
           
          
           
           this.getPFLoanTerms();
           if(this.loan_id > 0)
           {
               this.thread_key += 1;
               this.getApplicationSettings(this.loan_id);
               this.getLastPayrun(this.employee_id);
               this.editLoanInfo(this.loan_id);
               this.getApplicationApprovals(this.loan_id);
                // this.getEmployeeInfo(); // Start: Rejwan: 01-12-2025
           }
           else
           {  

               this.getAvailablePf();
               this.getPFSettings(); 
               this.getLastPayrun(this.employee_id);
               this.getBankInfo(this.employee_id);
               this.addNewLoan(1);
               this.getEmployeeInfo(this.employee_id); // Start: Rejwan: 16-02-2026 Front Routes
               
           }  
           if(this.atl_company_package_title == 'Provident Fund Only')
           {
               this.fdata.is_appear_in_payslip = 1;
           }

       }    
   }
</script>
<style>
.loan-card-title {
   /* text-align: center; */
   padding-bottom: 10px;
   font-size: 16px;
   /* color: #00c5fb !important; */
}

.loan_card_wrapper {
   padding-top: 12px;
   padding-bottom: 12px;
}
.pf_loan_form_front .b-overlay
{
	height: 100%;
}
.loan_form_bank_details .col-form-label {
	color: #3A52A6;
}
 
.ess-portal .ibox-content .custom-file-label span {
	font-size: 12px;
	color: #3A52A6;
	font-weight: unset;
}

#deduction_start_month_1-group input {
	background-color: #e9ecef;
	pointer-events: none;
}
#confirm_terms-group .custom-control-label::after {
	/* display: ; */
	top: 0.12rem;
} 
#confirm_terms-group .custom-control-label::before {
	top: 0.12rem;
}
#confirm_terms-group .custom-control-input.is-valid:checked ~ .custom-control-label::before {
	border-color: #3A52A6 !important;
	background-color: #3A52A6 !important;
}
/* Start: Rejwan: 07-01-2026 Attachment text show */
.bkash-ess-portal .ibox-content .custom-file-label span {
    font-size: 12px;
    color: #3A52A6 !important;
    font-weight: unset;
}
/* End: Rejwan: 07-01-2026 Attachment text show */
</style>

<!-- End: Rejwan: 09-02-2026 Front Routes -->
